/* eslint-disable */
/* tslint:disable */

/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import {
  NjmmisCheckResult,
  Benefit,
  McdType,
  McdSubtype,
  SlideType,
} from './globalTypes' // ====================================================
// GraphQL query operation: Person
// ====================================================

import {PersonVariables as PersonVariablesOrig} from '../types/Person'
import {Person as PersonOrig} from '../types/Person'
import {Person_person as Person_personOrig} from '../types/Person'
import {Person_person_mostRecentEligibilityDeterminations as Person_person_mostRecentEligibilityDeterminationsOrig} from '../types/Person'
import {Person_person_mostRecentAccount as Person_person_mostRecentAccountOrig} from '../types/Person'
import {WebformMergeResult} from 'utils/form/getWebformMergeResult'
import {parseWebformMergeResult} from 'utils/form/getWebformMergeResult'
import {serializeWebformMergeResult} from 'utils/form/getWebformMergeResult'
import {Person_person_webformMergeAttempts as Person_person_webformMergeAttemptsOrig} from '../types/Person'
import {ReceivedWebformResponse} from 'utils/form/getReceivedWebformResponse'
import {parseReceivedWebformResponse} from 'utils/form/getReceivedWebformResponse'
import {serializeReceivedWebformResponse} from 'utils/form/getReceivedWebformResponse'
import {Person_person_webformMergeAttempts_receivedWebform as Person_person_webformMergeAttempts_receivedWebformOrig} from '../types/Person'
import {Person_person_webformMergeAttempts_receivedWebform_webform as Person_person_webformMergeAttempts_receivedWebform_webformOrig} from '../types/Person'
import {Person_person_tasks as Person_person_tasksOrig} from '../types/Person'
import {Person_person_tasks_linkedTo as Person_person_tasks_linkedToOrig} from '../types/Person'
import {Person_person_tasks_createdBy as Person_person_tasks_createdByOrig} from '../types/Person'
import {Person_person_tasks_assignedTo as Person_person_tasks_assignedToOrig} from '../types/Person'
import {Person_person_accounts as Person_person_accountsOrig} from '../types/Person'
import {Person_person_documentFiles as Person_person_documentFilesOrig} from '../types/Person'
import {Person_person_documentFiles_documents as Person_person_documentFiles_documentsOrig} from '../types/Person'
import {Person_person_benefitOutcomes as Person_person_benefitOutcomesOrig} from '../types/Person'
import {Person_person_benefitOutcomes_application as Person_person_benefitOutcomes_applicationOrig} from '../types/Person'
import {Person_person_benefitOutcomes_application_RyanWhiteApplication as Person_person_benefitOutcomes_application_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_benefitOutcomes_application_SlideApplication as Person_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Person'
import {Person_person_benefitOutcomes_application_CharityCareApplication as Person_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_benefitOutcomes_application_MonitorApplication as Person_person_benefitOutcomes_application_MonitorApplicationOrig} from '../types/Person'
import {Person_person_benefitOutcomes_application_MonitorApplication_primaryPointOfContact as Person_person_benefitOutcomes_application_MonitorApplication_primaryPointOfContactOrig} from '../types/Person'
import {Person_person_benefitOutcomes_application_MedicaidApplication as Person_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications as Person_person_openPrimaryPointOfContactApplicationsOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication as Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person as Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_personOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications as Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications as Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication as Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication as Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication as Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication as Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_SlideApplication as Person_person_openPrimaryPointOfContactApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_SlideApplication_person as Person_person_openPrimaryPointOfContactApplications_SlideApplication_personOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications as Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications as Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication as Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication as Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication as Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication as Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_CharityCareApplication as Person_person_openPrimaryPointOfContactApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person as Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_personOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications as Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications as Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication as Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication as Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication as Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication as Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MonitorApplication as Person_person_openPrimaryPointOfContactApplications_MonitorApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person as Person_person_openPrimaryPointOfContactApplications_MonitorApplication_personOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications as Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications as Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication as Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication as Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication as Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication as Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact as Person_person_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContactOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MedicaidApplication as Person_person_openPrimaryPointOfContactApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person as Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_personOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications as Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications as Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication as Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication as Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication as Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication as Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications as Person_person_allOpenHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documentsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_applicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_filesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationshipsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPersonOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assetsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductionsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assetsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductionsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSourcesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication as Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication as Person_person_allOpenHouseholdMemberApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents as Person_person_allOpenHouseholdMemberApplications_SlideApplication_documentsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_application as Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_applicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_person as Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_files as Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_filesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers as Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person as Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person as Person_person_allOpenHouseholdMemberApplications_SlideApplication_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationshipsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPersonOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assetsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductionsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_assets as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_assetsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_deductions as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_deductionsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSourcesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication as Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication as Person_person_allOpenHouseholdMemberApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documentsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_applicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_filesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationshipsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPersonOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assetsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductionsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_assetsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductionsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSourcesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication as Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication as Person_person_allOpenHouseholdMemberApplications_MonitorApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documentsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_application as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_applicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_person as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_files as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_filesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationshipsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPersonOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assetsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductionsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_assets as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_assetsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_deductionsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSourcesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact as Person_person_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContactOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication as Person_person_allOpenHouseholdMemberApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documentsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_applicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_filesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_personOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationshipsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPersonOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assetsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductionsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_assetsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductionsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSourcesOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbersOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication as Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications as Person_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_RyanWhiteApplication as Person_person_openHouseholdMemberApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person as Person_person_openHouseholdMemberApplications_RyanWhiteApplication_personOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications as Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications as Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication as Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication as Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication as Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication as Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_SlideApplication as Person_person_openHouseholdMemberApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_SlideApplication_person as Person_person_openHouseholdMemberApplications_SlideApplication_personOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications as Person_person_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications as Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication as Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication as Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication as Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication as Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_CharityCareApplication as Person_person_openHouseholdMemberApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_CharityCareApplication_person as Person_person_openHouseholdMemberApplications_CharityCareApplication_personOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications as Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications as Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication as Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication as Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication as Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication as Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MonitorApplication as Person_person_openHouseholdMemberApplications_MonitorApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MonitorApplication_person as Person_person_openHouseholdMemberApplications_MonitorApplication_personOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications as Person_person_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications as Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication as Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication as Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication as Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication as Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact as Person_person_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContactOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MedicaidApplication as Person_person_openHouseholdMemberApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MedicaidApplication_person as Person_person_openHouseholdMemberApplications_MedicaidApplication_personOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications as Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications as Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication as Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication as Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication as Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication as Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openApplications as Person_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication as Person_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication_person as Person_person_openApplications_RyanWhiteApplication_personOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications as Person_person_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication_person_openApplications as Person_person_openApplications_RyanWhiteApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication as Person_person_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication as Person_person_openApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication as Person_person_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication as Person_person_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication_documents as Person_person_openApplications_RyanWhiteApplication_documentsOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication_documents_application as Person_person_openApplications_RyanWhiteApplication_documents_applicationOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication_documents_person as Person_person_openApplications_RyanWhiteApplication_documents_personOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication_documents_files as Person_person_openApplications_RyanWhiteApplication_documents_filesOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication_householdMembers as Person_person_openApplications_RyanWhiteApplication_householdMembersOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication_householdMembers_person as Person_person_openApplications_RyanWhiteApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_openApplications_RyanWhiteApplication_eligibilityDeterminations as Person_person_openApplications_RyanWhiteApplication_eligibilityDeterminationsOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication as Person_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication_person as Person_person_openApplications_SlideApplication_personOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication_person_openHouseholdMemberApplications as Person_person_openApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication_person_openApplications as Person_person_openApplications_SlideApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication as Person_person_openApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication_person_openApplications_SlideApplication as Person_person_openApplications_SlideApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication_person_openApplications_CharityCareApplication as Person_person_openApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication_person_openApplications_MedicaidApplication as Person_person_openApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication_documents as Person_person_openApplications_SlideApplication_documentsOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication_documents_application as Person_person_openApplications_SlideApplication_documents_applicationOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication_documents_person as Person_person_openApplications_SlideApplication_documents_personOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication_documents_files as Person_person_openApplications_SlideApplication_documents_filesOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication_householdMembers as Person_person_openApplications_SlideApplication_householdMembersOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication_householdMembers_person as Person_person_openApplications_SlideApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_openApplications_SlideApplication_eligibilityDeterminations as Person_person_openApplications_SlideApplication_eligibilityDeterminationsOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication as Person_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication_person as Person_person_openApplications_CharityCareApplication_personOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication_person_openHouseholdMemberApplications as Person_person_openApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication_person_openApplications as Person_person_openApplications_CharityCareApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication as Person_person_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication_person_openApplications_SlideApplication as Person_person_openApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication as Person_person_openApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication as Person_person_openApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication_documents as Person_person_openApplications_CharityCareApplication_documentsOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication_documents_application as Person_person_openApplications_CharityCareApplication_documents_applicationOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication_documents_person as Person_person_openApplications_CharityCareApplication_documents_personOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication_documents_files as Person_person_openApplications_CharityCareApplication_documents_filesOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication_householdMembers as Person_person_openApplications_CharityCareApplication_householdMembersOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication_householdMembers_person as Person_person_openApplications_CharityCareApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_openApplications_CharityCareApplication_eligibilityDeterminations as Person_person_openApplications_CharityCareApplication_eligibilityDeterminationsOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication as Person_person_openApplications_MonitorApplicationOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_person as Person_person_openApplications_MonitorApplication_personOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_person_openHouseholdMemberApplications as Person_person_openApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_person_openApplications as Person_person_openApplications_MonitorApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication as Person_person_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_person_openApplications_SlideApplication as Person_person_openApplications_MonitorApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_person_openApplications_CharityCareApplication as Person_person_openApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_person_openApplications_MedicaidApplication as Person_person_openApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_documents as Person_person_openApplications_MonitorApplication_documentsOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_documents_application as Person_person_openApplications_MonitorApplication_documents_applicationOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_documents_person as Person_person_openApplications_MonitorApplication_documents_personOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_documents_files as Person_person_openApplications_MonitorApplication_documents_filesOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_householdMembers as Person_person_openApplications_MonitorApplication_householdMembersOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_householdMembers_person as Person_person_openApplications_MonitorApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_eligibilityDeterminations as Person_person_openApplications_MonitorApplication_eligibilityDeterminationsOrig} from '../types/Person'
import {Person_person_openApplications_MonitorApplication_primaryPointOfContact as Person_person_openApplications_MonitorApplication_primaryPointOfContactOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication as Person_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication_person as Person_person_openApplications_MedicaidApplication_personOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication_person_openHouseholdMemberApplications as Person_person_openApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication_person_openApplications as Person_person_openApplications_MedicaidApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication as Person_person_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication_person_openApplications_SlideApplication as Person_person_openApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication as Person_person_openApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication as Person_person_openApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication_documents as Person_person_openApplications_MedicaidApplication_documentsOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication_documents_application as Person_person_openApplications_MedicaidApplication_documents_applicationOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication_documents_person as Person_person_openApplications_MedicaidApplication_documents_personOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication_documents_files as Person_person_openApplications_MedicaidApplication_documents_filesOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication_householdMembers as Person_person_openApplications_MedicaidApplication_householdMembersOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication_householdMembers_person as Person_person_openApplications_MedicaidApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_openApplications_MedicaidApplication_eligibilityDeterminations as Person_person_openApplications_MedicaidApplication_eligibilityDeterminationsOrig} from '../types/Person'
import {Person_person_allApplications as Person_person_allApplicationsOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication as Person_person_allApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_householdMembers as Person_person_allApplications_RyanWhiteApplication_householdMembersOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_householdMembers_person as Person_person_allApplications_RyanWhiteApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_assignedTo as Person_person_allApplications_RyanWhiteApplication_assignedToOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person as Person_person_allApplications_RyanWhiteApplication_personOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications as Person_person_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_openApplications as Person_person_allApplications_RyanWhiteApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication as Person_person_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication as Person_person_allApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication as Person_person_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication as Person_person_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_deductions as Person_person_allApplications_RyanWhiteApplication_person_deductionsOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_incomeSources as Person_person_allApplications_RyanWhiteApplication_person_incomeSourcesOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession as Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSessionOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards as Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes as Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomesOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application as Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_applicationOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication as Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication as Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication as Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers as Person_person_allApplications_RyanWhiteApplication_person_phoneNumbersOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession as Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSessionOrig} from '../types/Person'
import {Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards as Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication as Person_person_allApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_householdMembers as Person_person_allApplications_SlideApplication_householdMembersOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_householdMembers_person as Person_person_allApplications_SlideApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_assignedTo as Person_person_allApplications_SlideApplication_assignedToOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person as Person_person_allApplications_SlideApplication_personOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_openHouseholdMemberApplications as Person_person_allApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_openApplications as Person_person_allApplications_SlideApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication as Person_person_allApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_openApplications_SlideApplication as Person_person_allApplications_SlideApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_openApplications_CharityCareApplication as Person_person_allApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_openApplications_MedicaidApplication as Person_person_allApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_deductions as Person_person_allApplications_SlideApplication_person_deductionsOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_incomeSources as Person_person_allApplications_SlideApplication_person_incomeSourcesOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_incomeSources_esignSession as Person_person_allApplications_SlideApplication_person_incomeSources_esignSessionOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards as Person_person_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_benefitOutcomes as Person_person_allApplications_SlideApplication_person_benefitOutcomesOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_benefitOutcomes_application as Person_person_allApplications_SlideApplication_person_benefitOutcomes_applicationOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication as Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication as Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication as Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_phoneNumbers as Person_person_allApplications_SlideApplication_person_phoneNumbersOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSession as Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSessionOrig} from '../types/Person'
import {Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards as Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication as Person_person_allApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_householdMembers as Person_person_allApplications_CharityCareApplication_householdMembersOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_householdMembers_person as Person_person_allApplications_CharityCareApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_assignedTo as Person_person_allApplications_CharityCareApplication_assignedToOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person as Person_person_allApplications_CharityCareApplication_personOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_openHouseholdMemberApplications as Person_person_allApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_openApplications as Person_person_allApplications_CharityCareApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication as Person_person_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_openApplications_SlideApplication as Person_person_allApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication as Person_person_allApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication as Person_person_allApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_deductions as Person_person_allApplications_CharityCareApplication_person_deductionsOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_incomeSources as Person_person_allApplications_CharityCareApplication_person_incomeSourcesOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSession as Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSessionOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards as Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_benefitOutcomes as Person_person_allApplications_CharityCareApplication_person_benefitOutcomesOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application as Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_applicationOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication as Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication as Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication as Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_phoneNumbers as Person_person_allApplications_CharityCareApplication_person_phoneNumbersOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession as Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSessionOrig} from '../types/Person'
import {Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards as Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication as Person_person_allApplications_MonitorApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_householdMembers as Person_person_allApplications_MonitorApplication_householdMembersOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_householdMembers_person as Person_person_allApplications_MonitorApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_assignedTo as Person_person_allApplications_MonitorApplication_assignedToOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person as Person_person_allApplications_MonitorApplication_personOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_openHouseholdMemberApplications as Person_person_allApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_openApplications as Person_person_allApplications_MonitorApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication as Person_person_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_openApplications_SlideApplication as Person_person_allApplications_MonitorApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_openApplications_CharityCareApplication as Person_person_allApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_openApplications_MedicaidApplication as Person_person_allApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_deductions as Person_person_allApplications_MonitorApplication_person_deductionsOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_incomeSources as Person_person_allApplications_MonitorApplication_person_incomeSourcesOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_incomeSources_esignSession as Person_person_allApplications_MonitorApplication_person_incomeSources_esignSessionOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards as Person_person_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_benefitOutcomes as Person_person_allApplications_MonitorApplication_person_benefitOutcomesOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application as Person_person_allApplications_MonitorApplication_person_benefitOutcomes_applicationOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication as Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication as Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication as Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_phoneNumbers as Person_person_allApplications_MonitorApplication_person_phoneNumbersOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession as Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSessionOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards as Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Person'
import {Person_person_allApplications_MonitorApplication_primaryPointOfContact as Person_person_allApplications_MonitorApplication_primaryPointOfContactOrig} from '../types/Person'
import {deserializeMcdSubtype} from 'graphql/converters'
import {serializeMcdSubtype} from 'graphql/converters'
import {deserializeMcdType} from 'graphql/converters'
import {serializeMcdType} from 'graphql/converters'
import {Person_person_allApplications_MedicaidApplication as Person_person_allApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_householdMembers as Person_person_allApplications_MedicaidApplication_householdMembersOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_householdMembers_person as Person_person_allApplications_MedicaidApplication_householdMembers_personOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_assignedTo as Person_person_allApplications_MedicaidApplication_assignedToOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person as Person_person_allApplications_MedicaidApplication_personOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_openHouseholdMemberApplications as Person_person_allApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_openApplications as Person_person_allApplications_MedicaidApplication_person_openApplicationsOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication as Person_person_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_openApplications_SlideApplication as Person_person_allApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication as Person_person_allApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Person'
import {BenefitType} from 'utils/benefits'
import {deserializeBenefit} from 'graphql/converters'
import {serializeBenefit} from 'graphql/converters'
import {Person_person_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication as Person_person_allApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_deductions as Person_person_allApplications_MedicaidApplication_person_deductionsOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_incomeSources as Person_person_allApplications_MedicaidApplication_person_incomeSourcesOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSession as Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSessionOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards as Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_benefitOutcomes as Person_person_allApplications_MedicaidApplication_person_benefitOutcomesOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application as Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_applicationOrig} from '../types/Person'
import {deserializeSlideType} from 'graphql/converters'
import {serializeSlideType} from 'graphql/converters'
import {Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication as Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication as Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication as Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_phoneNumbers as Person_person_allApplications_MedicaidApplication_person_phoneNumbersOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession as Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSessionOrig} from '../types/Person'
import {Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards as Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Person'
import {Person_person_relationships as Person_person_relationshipsOrig} from '../types/Person'
import {DeserializedFieldsUpdatedAt} from 'utils/form/getFieldsUpdatedAt'
import {parseFieldsUpdatedAt} from 'utils/form/getFieldsUpdatedAt'
import {serializeFieldsUpdatedAt} from 'utils/form/getFieldsUpdatedAt'
import {Person_person_relationships_otherPerson as Person_person_relationships_otherPersonOrig} from '../types/Person'
import {Person_person_relationships_otherPerson_openHouseholdMemberApplications as Person_person_relationships_otherPerson_openHouseholdMemberApplicationsOrig} from '../types/Person'
import {Person_person_relationships_otherPerson_openHouseholdMemberApplications_person as Person_person_relationships_otherPerson_openHouseholdMemberApplications_personOrig} from '../types/Person'
import {Person_person_relationships_otherPerson_openApplications as Person_person_relationships_otherPerson_openApplicationsOrig} from '../types/Person'
import {Person_person_relationships_otherPerson_openApplications_person as Person_person_relationships_otherPerson_openApplications_personOrig} from '../types/Person'
import {Person_person_relationships_otherPerson_assets as Person_person_relationships_otherPerson_assetsOrig} from '../types/Person'
import {Person_person_relationships_otherPerson_deductions as Person_person_relationships_otherPerson_deductionsOrig} from '../types/Person'
import {Person_person_relationships_otherPerson_incomeSources as Person_person_relationships_otherPerson_incomeSourcesOrig} from '../types/Person'
import {Person_person_relationships_otherPerson_phoneNumbers as Person_person_relationships_otherPerson_phoneNumbersOrig} from '../types/Person'
import {Person_person_openTriages as Person_person_openTriagesOrig} from '../types/Person'
import {Person_person_openTriages_eligibilityDeterminations as Person_person_openTriages_eligibilityDeterminationsOrig} from '../types/Person'
import {Person_person_openTriages_account as Person_person_openTriages_accountOrig} from '../types/Person'
import {Person_person_triages as Person_person_triagesOrig} from '../types/Person'
import {Person_person_triages_assignedTo as Person_person_triages_assignedToOrig} from '../types/Person'
import {AdditionalData} from 'utils/getAdditionalData'
import {parseAdditionalData} from 'utils/getAdditionalData'
import {serializeAdditionalData} from 'utils/getAdditionalData'
import {Person_person_triages_eligibilityDeterminations as Person_person_triages_eligibilityDeterminationsOrig} from '../types/Person'
import {deserializeNjmmisCheckResult} from 'graphql/converters'
import {serializeNjmmisCheckResult} from 'graphql/converters'
import formatISO from 'date-fns/formatISO'
import {parseDate} from 'utils/form/fieldTypes'
import {formatISODate} from 'utils/date'
import {Person_person_triages_account as Person_person_triages_accountOrig} from '../types/Person'
import {Person_person_assets as Person_person_assetsOrig} from '../types/Person'
import {Person_person_deductions as Person_person_deductionsOrig} from '../types/Person'
import {Person_person_incomeSources as Person_person_incomeSourcesOrig} from '../types/Person'
import {Person_person_phoneNumbers as Person_person_phoneNumbersOrig} from '../types/Person'
export interface Person_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializePerson_person_phoneNumbers = (
  serialized: Person_person_phoneNumbersOrig
): Person_person_phoneNumbers => ({...serialized})
export const serializePerson_person_phoneNumbers = (
  deserialized: Person_person_phoneNumbers
): Person_person_phoneNumbersOrig => ({...deserialized})
export interface Person_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializePerson_person_incomeSources = (
  serialized: Person_person_incomeSourcesOrig
): Person_person_incomeSources => ({...serialized})
export const serializePerson_person_incomeSources = (
  deserialized: Person_person_incomeSources
): Person_person_incomeSourcesOrig => ({...deserialized})
export interface Person_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_deductions = (
  serialized: Person_person_deductionsOrig
): Person_person_deductions => ({...serialized})
export const serializePerson_person_deductions = (
  deserialized: Person_person_deductions
): Person_person_deductionsOrig => ({...deserialized})
export interface Person_person_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializePerson_person_assets = (
  serialized: Person_person_assetsOrig
): Person_person_assets => ({...serialized})
export const serializePerson_person_assets = (
  deserialized: Person_person_assets
): Person_person_assetsOrig => ({...deserialized})
export interface Person_person_triages_account {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializePerson_person_triages_account = (
  serialized: Person_person_triages_accountOrig
): Person_person_triages_account => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializePerson_person_triages_account = (
  deserialized: Person_person_triages_account
): Person_person_triages_accountOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface Person_person_triages_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializePerson_person_triages_eligibilityDeterminations = (
  serialized: Person_person_triages_eligibilityDeterminationsOrig
): Person_person_triages_eligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializePerson_person_triages_eligibilityDeterminations = (
  deserialized: Person_person_triages_eligibilityDeterminations
): Person_person_triages_eligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface Person_person_triages_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializePerson_person_triages_assignedTo = (
  serialized: Person_person_triages_assignedToOrig
): Person_person_triages_assignedTo => ({...serialized})
export const serializePerson_person_triages_assignedTo = (
  deserialized: Person_person_triages_assignedTo
): Person_person_triages_assignedToOrig => ({...deserialized})
export interface Person_person_triages {
  __typename: 'Triage'
  id: string
  account: Person_person_triages_account
  createdAt: Date
  updatedAt: Date
  status: string
  closeReason: string | null
  closeComment: string | null
  eligibilityDeterminations: Person_person_triages_eligibilityDeterminations[]
  assignedTo: Person_person_triages_assignedTo | null
}
export const deserializePerson_person_triages = (
  serialized: Person_person_triagesOrig
): Person_person_triages => ({
  ...serialized,
  account: deserializePerson_person_triages_account(serialized.account),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializePerson_person_triages_eligibilityDeterminations
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializePerson_person_triages_assignedTo(serialized.assignedTo)
      : serialized.assignedTo,
})
export const serializePerson_person_triages = (
  deserialized: Person_person_triages
): Person_person_triagesOrig => ({
  ...deserialized,
  account: serializePerson_person_triages_account(deserialized.account),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializePerson_person_triages_eligibilityDeterminations
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializePerson_person_triages_assignedTo(deserialized.assignedTo)
      : deserialized.assignedTo,
})
export interface Person_person_openTriages_account {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
}
export const deserializePerson_person_openTriages_account = (
  serialized: Person_person_openTriages_accountOrig
): Person_person_openTriages_account => ({...serialized})
export const serializePerson_person_openTriages_account = (
  deserialized: Person_person_openTriages_account
): Person_person_openTriages_accountOrig => ({...deserialized})
export interface Person_person_openTriages_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializePerson_person_openTriages_eligibilityDeterminations = (
  serialized: Person_person_openTriages_eligibilityDeterminationsOrig
): Person_person_openTriages_eligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializePerson_person_openTriages_eligibilityDeterminations = (
  deserialized: Person_person_openTriages_eligibilityDeterminations
): Person_person_openTriages_eligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface Person_person_openTriages {
  __typename: 'Triage'
  id: string
  status: string
  account: Person_person_openTriages_account
  eligibilityDeterminations: Person_person_openTriages_eligibilityDeterminations[]
}
export const deserializePerson_person_openTriages = (
  serialized: Person_person_openTriagesOrig
): Person_person_openTriages => ({
  ...serialized,
  account: deserializePerson_person_openTriages_account(serialized.account),
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializePerson_person_openTriages_eligibilityDeterminations
  ),
})
export const serializePerson_person_openTriages = (
  deserialized: Person_person_openTriages
): Person_person_openTriagesOrig => ({
  ...deserialized,
  account: serializePerson_person_openTriages_account(deserialized.account),
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializePerson_person_openTriages_eligibilityDeterminations
  ),
})
export interface Person_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializePerson_person_relationships_otherPerson_phoneNumbers = (
  serialized: Person_person_relationships_otherPerson_phoneNumbersOrig
): Person_person_relationships_otherPerson_phoneNumbers => ({...serialized})
export const serializePerson_person_relationships_otherPerson_phoneNumbers = (
  deserialized: Person_person_relationships_otherPerson_phoneNumbers
): Person_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
})
export interface Person_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializePerson_person_relationships_otherPerson_incomeSources = (
  serialized: Person_person_relationships_otherPerson_incomeSourcesOrig
): Person_person_relationships_otherPerson_incomeSources => ({...serialized})
export const serializePerson_person_relationships_otherPerson_incomeSources = (
  deserialized: Person_person_relationships_otherPerson_incomeSources
): Person_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
})
export interface Person_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_relationships_otherPerson_deductions = (
  serialized: Person_person_relationships_otherPerson_deductionsOrig
): Person_person_relationships_otherPerson_deductions => ({...serialized})
export const serializePerson_person_relationships_otherPerson_deductions = (
  deserialized: Person_person_relationships_otherPerson_deductions
): Person_person_relationships_otherPerson_deductionsOrig => ({...deserialized})
export interface Person_person_relationships_otherPerson_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializePerson_person_relationships_otherPerson_assets = (
  serialized: Person_person_relationships_otherPerson_assetsOrig
): Person_person_relationships_otherPerson_assets => ({...serialized})
export const serializePerson_person_relationships_otherPerson_assets = (
  deserialized: Person_person_relationships_otherPerson_assets
): Person_person_relationships_otherPerson_assetsOrig => ({...deserialized})
export interface Person_person_relationships_otherPerson_openApplications_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_relationships_otherPerson_openApplications_person = (
  serialized: Person_person_relationships_otherPerson_openApplications_personOrig
): Person_person_relationships_otherPerson_openApplications_person => ({
  ...serialized,
})
export const serializePerson_person_relationships_otherPerson_openApplications_person = (
  deserialized: Person_person_relationships_otherPerson_openApplications_person
): Person_person_relationships_otherPerson_openApplications_personOrig => ({
  ...deserialized,
})
export interface Person_person_relationships_otherPerson_openApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  person: Person_person_relationships_otherPerson_openApplications_person
}
export const deserializePerson_person_relationships_otherPerson_openApplications = (
  serialized: Person_person_relationships_otherPerson_openApplicationsOrig
): Person_person_relationships_otherPerson_openApplications => ({
  ...serialized,
  person: deserializePerson_person_relationships_otherPerson_openApplications_person(
    serialized.person
  ),
})
export const serializePerson_person_relationships_otherPerson_openApplications = (
  deserialized: Person_person_relationships_otherPerson_openApplications
): Person_person_relationships_otherPerson_openApplicationsOrig => ({
  ...deserialized,
  person: serializePerson_person_relationships_otherPerson_openApplications_person(
    deserialized.person
  ),
})
export interface Person_person_relationships_otherPerson_openHouseholdMemberApplications_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_relationships_otherPerson_openHouseholdMemberApplications_person = (
  serialized: Person_person_relationships_otherPerson_openHouseholdMemberApplications_personOrig
): Person_person_relationships_otherPerson_openHouseholdMemberApplications_person => ({
  ...serialized,
})
export const serializePerson_person_relationships_otherPerson_openHouseholdMemberApplications_person = (
  deserialized: Person_person_relationships_otherPerson_openHouseholdMemberApplications_person
): Person_person_relationships_otherPerson_openHouseholdMemberApplications_personOrig => ({
  ...deserialized,
})
export interface Person_person_relationships_otherPerson_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  person: Person_person_relationships_otherPerson_openHouseholdMemberApplications_person
}
export const deserializePerson_person_relationships_otherPerson_openHouseholdMemberApplications = (
  serialized: Person_person_relationships_otherPerson_openHouseholdMemberApplicationsOrig
): Person_person_relationships_otherPerson_openHouseholdMemberApplications => ({
  ...serialized,
  person: deserializePerson_person_relationships_otherPerson_openHouseholdMemberApplications_person(
    serialized.person
  ),
})
export const serializePerson_person_relationships_otherPerson_openHouseholdMemberApplications = (
  deserialized: Person_person_relationships_otherPerson_openHouseholdMemberApplications
): Person_person_relationships_otherPerson_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  person: serializePerson_person_relationships_otherPerson_openHouseholdMemberApplications_person(
    deserialized.person
  ),
})
export interface Person_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: Person_person_relationships_otherPerson_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: Person_person_relationships_otherPerson_incomeSources[]
  deductions: Person_person_relationships_otherPerson_deductions[]
  assets: Person_person_relationships_otherPerson_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
  openApplications: Person_person_relationships_otherPerson_openApplications[]
  openHouseholdMemberApplications: Person_person_relationships_otherPerson_openHouseholdMemberApplications[]
}
export const deserializePerson_person_relationships_otherPerson = (
  serialized: Person_person_relationships_otherPersonOrig
): Person_person_relationships_otherPerson => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_relationships_otherPerson_deductions
  ),
  assets: serialized.assets.map(
    deserializePerson_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_relationships_otherPerson_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_relationships_otherPerson_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_relationships_otherPerson = (
  deserialized: Person_person_relationships_otherPerson
): Person_person_relationships_otherPersonOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_relationships_otherPerson_deductions
  ),
  assets: deserialized.assets.map(
    serializePerson_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_relationships_otherPerson_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_relationships_otherPerson_openHouseholdMemberApplications
  ),
})
export interface Person_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  otherPerson: Person_person_relationships_otherPerson
  liveTogether: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializePerson_person_relationships = (
  serialized: Person_person_relationshipsOrig
): Person_person_relationships => ({
  ...serialized,
  otherPerson: deserializePerson_person_relationships_otherPerson(
    serialized.otherPerson
  ),
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializePerson_person_relationships = (
  deserialized: Person_person_relationships
): Person_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializePerson_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializePerson_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards
): Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession = (
  serialized: Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSessionOrig
): Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializePerson_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializePerson_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession
): Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializePerson_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Person_person_allApplications_MedicaidApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Person_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession | null
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_phoneNumbers = (
  serialized: Person_person_allApplications_MedicaidApplication_person_phoneNumbersOrig
): Person_person_allApplications_MedicaidApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializePerson_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializePerson_person_allApplications_MedicaidApplication_person_phoneNumbers = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_phoneNumbers
): Person_person_allApplications_MedicaidApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializePerson_person_allApplications_MedicaidApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication
): Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication
): Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplicationOrig
): Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication
): Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application =
  | Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication
  | Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication
  | Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication
export const deserializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application = (
  serialized: Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_applicationOrig
): Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application'
  )
}
export const serializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application
): Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application'
  )
}
export interface Person_person_allApplications_MedicaidApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Person_person_allApplications_MedicaidApplication_person_benefitOutcomes_application | null
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes = (
  serialized: Person_person_allApplications_MedicaidApplication_person_benefitOutcomesOrig
): Person_person_allApplications_MedicaidApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_benefitOutcomes
): Person_person_allApplications_MedicaidApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizardsOrig
): Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializePerson_person_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards
): Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_incomeSources_esignSession = (
  serialized: Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSessionOrig
): Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializePerson_person_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializePerson_person_allApplications_MedicaidApplication_person_incomeSources_esignSession = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSession
): Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializePerson_person_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Person_person_allApplications_MedicaidApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Person_person_allApplications_MedicaidApplication_person_incomeSources_esignSession | null
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_incomeSources = (
  serialized: Person_person_allApplications_MedicaidApplication_person_incomeSourcesOrig
): Person_person_allApplications_MedicaidApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializePerson_person_allApplications_MedicaidApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializePerson_person_allApplications_MedicaidApplication_person_incomeSources = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_incomeSources
): Person_person_allApplications_MedicaidApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializePerson_person_allApplications_MedicaidApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Person_person_allApplications_MedicaidApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_deductions = (
  serialized: Person_person_allApplications_MedicaidApplication_person_deductionsOrig
): Person_person_allApplications_MedicaidApplication_person_deductions => ({
  ...serialized,
})
export const serializePerson_person_allApplications_MedicaidApplication_person_deductions = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_deductions
): Person_person_allApplications_MedicaidApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_allApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication
): Person_person_allApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_allApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication
): Person_person_allApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_MedicaidApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_allApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig
): Person_person_allApplications_MedicaidApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_openApplications_SlideApplication
): Person_person_allApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
): Person_person_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_allApplications_MedicaidApplication_person_openApplications =
  | Person_person_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication
  | Person_person_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication
  | Person_person_allApplications_MedicaidApplication_person_openApplications_SlideApplication
  | Person_person_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_allApplications_MedicaidApplication_person_openApplications = (
  serialized: Person_person_allApplications_MedicaidApplication_person_openApplicationsOrig
): Person_person_allApplications_MedicaidApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allApplications_MedicaidApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_MedicaidApplication_person_openApplications'
  )
}
export const serializePerson_person_allApplications_MedicaidApplication_person_openApplications = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_openApplications
): Person_person_allApplications_MedicaidApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allApplications_MedicaidApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_MedicaidApplication_person_openApplications'
  )
}
export interface Person_person_allApplications_MedicaidApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_allApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_allApplications_MedicaidApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_allApplications_MedicaidApplication_person_openHouseholdMemberApplications
): Person_person_allApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_MedicaidApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Person_person_allApplications_MedicaidApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Person_person_allApplications_MedicaidApplication_person_benefitOutcomes[]
  incomeSources: Person_person_allApplications_MedicaidApplication_person_incomeSources[]
  deductions: Person_person_allApplications_MedicaidApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  openApplications: Person_person_allApplications_MedicaidApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_allApplications_MedicaidApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_allApplications_MedicaidApplication_person = (
  serialized: Person_person_allApplications_MedicaidApplication_personOrig
): Person_person_allApplications_MedicaidApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allApplications_MedicaidApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allApplications_MedicaidApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allApplications_MedicaidApplication_person_deductions
  ),
  openApplications: serialized.openApplications.map(
    deserializePerson_person_allApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_allApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_allApplications_MedicaidApplication_person = (
  deserialized: Person_person_allApplications_MedicaidApplication_person
): Person_person_allApplications_MedicaidApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allApplications_MedicaidApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializePerson_person_allApplications_MedicaidApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allApplications_MedicaidApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allApplications_MedicaidApplication_person_deductions
  ),
  openApplications: deserialized.openApplications.map(
    serializePerson_person_allApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_allApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_allApplications_MedicaidApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializePerson_person_allApplications_MedicaidApplication_assignedTo = (
  serialized: Person_person_allApplications_MedicaidApplication_assignedToOrig
): Person_person_allApplications_MedicaidApplication_assignedTo => ({
  ...serialized,
})
export const serializePerson_person_allApplications_MedicaidApplication_assignedTo = (
  deserialized: Person_person_allApplications_MedicaidApplication_assignedTo
): Person_person_allApplications_MedicaidApplication_assignedToOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_MedicaidApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allApplications_MedicaidApplication_householdMembers_person = (
  serialized: Person_person_allApplications_MedicaidApplication_householdMembers_personOrig
): Person_person_allApplications_MedicaidApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_allApplications_MedicaidApplication_householdMembers_person = (
  deserialized: Person_person_allApplications_MedicaidApplication_householdMembers_person
): Person_person_allApplications_MedicaidApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_MedicaidApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: Person_person_allApplications_MedicaidApplication_householdMembers_person
}
export const deserializePerson_person_allApplications_MedicaidApplication_householdMembers = (
  serialized: Person_person_allApplications_MedicaidApplication_householdMembersOrig
): Person_person_allApplications_MedicaidApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_allApplications_MedicaidApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_allApplications_MedicaidApplication_householdMembers = (
  deserialized: Person_person_allApplications_MedicaidApplication_householdMembers
): Person_person_allApplications_MedicaidApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_allApplications_MedicaidApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_allApplications_MedicaidApplication {
  __typename: 'MedicaidApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  initialDateOfService: Date | null
  mcdType: string
  mcdSubtype: string | null
  person: Person_person_allApplications_MedicaidApplication_person
  assignedTo: Person_person_allApplications_MedicaidApplication_assignedTo | null
  householdMembers: Person_person_allApplications_MedicaidApplication_householdMembers[]
}
export const deserializePerson_person_allApplications_MedicaidApplication = (
  serialized: Person_person_allApplications_MedicaidApplicationOrig
): Person_person_allApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  mcdType: deserializeMcdType(serialized.mcdType),
  mcdSubtype:
    serialized.mcdSubtype != null
      ? deserializeMcdSubtype(serialized.mcdSubtype)
      : serialized.mcdSubtype,
  person: deserializePerson_person_allApplications_MedicaidApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializePerson_person_allApplications_MedicaidApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_allApplications_MedicaidApplication_householdMembers
  ),
})
export const serializePerson_person_allApplications_MedicaidApplication = (
  deserialized: Person_person_allApplications_MedicaidApplication
): Person_person_allApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  mcdType: serializeMcdType(deserialized.mcdType),
  mcdSubtype:
    deserialized.mcdSubtype != null
      ? serializeMcdSubtype(deserialized.mcdSubtype)
      : deserialized.mcdSubtype,
  person: serializePerson_person_allApplications_MedicaidApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializePerson_person_allApplications_MedicaidApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_allApplications_MedicaidApplication_householdMembers
  ),
})
export interface Person_person_allApplications_MonitorApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allApplications_MonitorApplication_primaryPointOfContact = (
  serialized: Person_person_allApplications_MonitorApplication_primaryPointOfContactOrig
): Person_person_allApplications_MonitorApplication_primaryPointOfContact => ({
  ...serialized,
})
export const serializePerson_person_allApplications_MonitorApplication_primaryPointOfContact = (
  deserialized: Person_person_allApplications_MonitorApplication_primaryPointOfContact
): Person_person_allApplications_MonitorApplication_primaryPointOfContactOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializePerson_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializePerson_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards
): Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializePerson_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession = (
  serialized: Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSessionOrig
): Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializePerson_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializePerson_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession = (
  deserialized: Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession
): Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializePerson_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Person_person_allApplications_MonitorApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Person_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession | null
}
export const deserializePerson_person_allApplications_MonitorApplication_person_phoneNumbers = (
  serialized: Person_person_allApplications_MonitorApplication_person_phoneNumbersOrig
): Person_person_allApplications_MonitorApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializePerson_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializePerson_person_allApplications_MonitorApplication_person_phoneNumbers = (
  deserialized: Person_person_allApplications_MonitorApplication_person_phoneNumbers
): Person_person_allApplications_MonitorApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializePerson_person_allApplications_MonitorApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication
): Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication
): Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplicationOrig
): Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication
): Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application =
  | Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication
  | Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication
  | Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication
export const deserializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application = (
  serialized: Person_person_allApplications_MonitorApplication_person_benefitOutcomes_applicationOrig
): Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application'
  )
}
export const serializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application = (
  deserialized: Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application
): Person_person_allApplications_MonitorApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application'
  )
}
export interface Person_person_allApplications_MonitorApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Person_person_allApplications_MonitorApplication_person_benefitOutcomes_application | null
}
export const deserializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes = (
  serialized: Person_person_allApplications_MonitorApplication_person_benefitOutcomesOrig
): Person_person_allApplications_MonitorApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes = (
  deserialized: Person_person_allApplications_MonitorApplication_person_benefitOutcomes
): Person_person_allApplications_MonitorApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Person_person_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializePerson_person_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: Person_person_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizardsOrig
): Person_person_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializePerson_person_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: Person_person_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards
): Person_person_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Person_person_allApplications_MonitorApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Person_person_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializePerson_person_allApplications_MonitorApplication_person_incomeSources_esignSession = (
  serialized: Person_person_allApplications_MonitorApplication_person_incomeSources_esignSessionOrig
): Person_person_allApplications_MonitorApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializePerson_person_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializePerson_person_allApplications_MonitorApplication_person_incomeSources_esignSession = (
  deserialized: Person_person_allApplications_MonitorApplication_person_incomeSources_esignSession
): Person_person_allApplications_MonitorApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializePerson_person_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Person_person_allApplications_MonitorApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Person_person_allApplications_MonitorApplication_person_incomeSources_esignSession | null
}
export const deserializePerson_person_allApplications_MonitorApplication_person_incomeSources = (
  serialized: Person_person_allApplications_MonitorApplication_person_incomeSourcesOrig
): Person_person_allApplications_MonitorApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializePerson_person_allApplications_MonitorApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializePerson_person_allApplications_MonitorApplication_person_incomeSources = (
  deserialized: Person_person_allApplications_MonitorApplication_person_incomeSources
): Person_person_allApplications_MonitorApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializePerson_person_allApplications_MonitorApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Person_person_allApplications_MonitorApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allApplications_MonitorApplication_person_deductions = (
  serialized: Person_person_allApplications_MonitorApplication_person_deductionsOrig
): Person_person_allApplications_MonitorApplication_person_deductions => ({
  ...serialized,
})
export const serializePerson_person_allApplications_MonitorApplication_person_deductions = (
  deserialized: Person_person_allApplications_MonitorApplication_person_deductions
): Person_person_allApplications_MonitorApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_MonitorApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_allApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_allApplications_MonitorApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_allApplications_MonitorApplication_person_openApplications_MedicaidApplication
): Person_person_allApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_MonitorApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_allApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_allApplications_MonitorApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_allApplications_MonitorApplication_person_openApplications_CharityCareApplication
): Person_person_allApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_MonitorApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_MonitorApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_allApplications_MonitorApplication_person_openApplications_SlideApplicationOrig
): Person_person_allApplications_MonitorApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_MonitorApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_allApplications_MonitorApplication_person_openApplications_SlideApplication
): Person_person_allApplications_MonitorApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
): Person_person_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_allApplications_MonitorApplication_person_openApplications =
  | Person_person_allApplications_MonitorApplication_person_openApplications_MedicaidApplication
  | Person_person_allApplications_MonitorApplication_person_openApplications_CharityCareApplication
  | Person_person_allApplications_MonitorApplication_person_openApplications_SlideApplication
  | Person_person_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_allApplications_MonitorApplication_person_openApplications = (
  serialized: Person_person_allApplications_MonitorApplication_person_openApplicationsOrig
): Person_person_allApplications_MonitorApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_allApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allApplications_MonitorApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_MonitorApplication_person_openApplications'
  )
}
export const serializePerson_person_allApplications_MonitorApplication_person_openApplications = (
  deserialized: Person_person_allApplications_MonitorApplication_person_openApplications
): Person_person_allApplications_MonitorApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_allApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allApplications_MonitorApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_MonitorApplication_person_openApplications'
  )
}
export interface Person_person_allApplications_MonitorApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_allApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_allApplications_MonitorApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_allApplications_MonitorApplication_person_openHouseholdMemberApplications
): Person_person_allApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_MonitorApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Person_person_allApplications_MonitorApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Person_person_allApplications_MonitorApplication_person_benefitOutcomes[]
  incomeSources: Person_person_allApplications_MonitorApplication_person_incomeSources[]
  deductions: Person_person_allApplications_MonitorApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  openApplications: Person_person_allApplications_MonitorApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_allApplications_MonitorApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_allApplications_MonitorApplication_person = (
  serialized: Person_person_allApplications_MonitorApplication_personOrig
): Person_person_allApplications_MonitorApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allApplications_MonitorApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allApplications_MonitorApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allApplications_MonitorApplication_person_deductions
  ),
  openApplications: serialized.openApplications.map(
    deserializePerson_person_allApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_allApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_allApplications_MonitorApplication_person = (
  deserialized: Person_person_allApplications_MonitorApplication_person
): Person_person_allApplications_MonitorApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allApplications_MonitorApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializePerson_person_allApplications_MonitorApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allApplications_MonitorApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allApplications_MonitorApplication_person_deductions
  ),
  openApplications: deserialized.openApplications.map(
    serializePerson_person_allApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_allApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_allApplications_MonitorApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializePerson_person_allApplications_MonitorApplication_assignedTo = (
  serialized: Person_person_allApplications_MonitorApplication_assignedToOrig
): Person_person_allApplications_MonitorApplication_assignedTo => ({
  ...serialized,
})
export const serializePerson_person_allApplications_MonitorApplication_assignedTo = (
  deserialized: Person_person_allApplications_MonitorApplication_assignedTo
): Person_person_allApplications_MonitorApplication_assignedToOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_MonitorApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allApplications_MonitorApplication_householdMembers_person = (
  serialized: Person_person_allApplications_MonitorApplication_householdMembers_personOrig
): Person_person_allApplications_MonitorApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_allApplications_MonitorApplication_householdMembers_person = (
  deserialized: Person_person_allApplications_MonitorApplication_householdMembers_person
): Person_person_allApplications_MonitorApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_MonitorApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: Person_person_allApplications_MonitorApplication_householdMembers_person
}
export const deserializePerson_person_allApplications_MonitorApplication_householdMembers = (
  serialized: Person_person_allApplications_MonitorApplication_householdMembersOrig
): Person_person_allApplications_MonitorApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_allApplications_MonitorApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_allApplications_MonitorApplication_householdMembers = (
  deserialized: Person_person_allApplications_MonitorApplication_householdMembers
): Person_person_allApplications_MonitorApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_allApplications_MonitorApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_allApplications_MonitorApplication {
  __typename: 'MonitorApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  applicationType: string | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  darSubmitDate: Date | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  primaryPointOfContact: Person_person_allApplications_MonitorApplication_primaryPointOfContact | null
  initialDateOfService: Date | null
  person: Person_person_allApplications_MonitorApplication_person
  assignedTo: Person_person_allApplications_MonitorApplication_assignedTo | null
  householdMembers: Person_person_allApplications_MonitorApplication_householdMembers[]
}
export const deserializePerson_person_allApplications_MonitorApplication = (
  serialized: Person_person_allApplications_MonitorApplicationOrig
): Person_person_allApplications_MonitorApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  darSubmitDate:
    serialized.darSubmitDate != null
      ? parseDate(serialized.darSubmitDate)
      : serialized.darSubmitDate,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializePerson_person_allApplications_MonitorApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  person: deserializePerson_person_allApplications_MonitorApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializePerson_person_allApplications_MonitorApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_allApplications_MonitorApplication_householdMembers
  ),
})
export const serializePerson_person_allApplications_MonitorApplication = (
  deserialized: Person_person_allApplications_MonitorApplication
): Person_person_allApplications_MonitorApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  darSubmitDate:
    deserialized.darSubmitDate != null
      ? formatISODate(deserialized.darSubmitDate)
      : deserialized.darSubmitDate,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializePerson_person_allApplications_MonitorApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  person: serializePerson_person_allApplications_MonitorApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializePerson_person_allApplications_MonitorApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_allApplications_MonitorApplication_householdMembers
  ),
})
export interface Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializePerson_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards
): Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession = (
  serialized: Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSessionOrig
): Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializePerson_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializePerson_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession
): Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializePerson_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Person_person_allApplications_CharityCareApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Person_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession | null
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_phoneNumbers = (
  serialized: Person_person_allApplications_CharityCareApplication_person_phoneNumbersOrig
): Person_person_allApplications_CharityCareApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializePerson_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializePerson_person_allApplications_CharityCareApplication_person_phoneNumbers = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_phoneNumbers
): Person_person_allApplications_CharityCareApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializePerson_person_allApplications_CharityCareApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication
): Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication
): Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplicationOrig
): Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication
): Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application =
  | Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication
  | Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication
  | Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication
export const deserializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application = (
  serialized: Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_applicationOrig
): Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application'
  )
}
export const serializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application
): Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application'
  )
}
export interface Person_person_allApplications_CharityCareApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Person_person_allApplications_CharityCareApplication_person_benefitOutcomes_application | null
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes = (
  serialized: Person_person_allApplications_CharityCareApplication_person_benefitOutcomesOrig
): Person_person_allApplications_CharityCareApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_benefitOutcomes
): Person_person_allApplications_CharityCareApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizardsOrig
): Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializePerson_person_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards
): Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_incomeSources_esignSession = (
  serialized: Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSessionOrig
): Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializePerson_person_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializePerson_person_allApplications_CharityCareApplication_person_incomeSources_esignSession = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSession
): Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializePerson_person_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Person_person_allApplications_CharityCareApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Person_person_allApplications_CharityCareApplication_person_incomeSources_esignSession | null
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_incomeSources = (
  serialized: Person_person_allApplications_CharityCareApplication_person_incomeSourcesOrig
): Person_person_allApplications_CharityCareApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializePerson_person_allApplications_CharityCareApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializePerson_person_allApplications_CharityCareApplication_person_incomeSources = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_incomeSources
): Person_person_allApplications_CharityCareApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializePerson_person_allApplications_CharityCareApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Person_person_allApplications_CharityCareApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_deductions = (
  serialized: Person_person_allApplications_CharityCareApplication_person_deductionsOrig
): Person_person_allApplications_CharityCareApplication_person_deductions => ({
  ...serialized,
})
export const serializePerson_person_allApplications_CharityCareApplication_person_deductions = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_deductions
): Person_person_allApplications_CharityCareApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_allApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication
): Person_person_allApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_allApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication
): Person_person_allApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_CharityCareApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_allApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig
): Person_person_allApplications_CharityCareApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_openApplications_SlideApplication
): Person_person_allApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
): Person_person_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_allApplications_CharityCareApplication_person_openApplications =
  | Person_person_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication
  | Person_person_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication
  | Person_person_allApplications_CharityCareApplication_person_openApplications_SlideApplication
  | Person_person_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_allApplications_CharityCareApplication_person_openApplications = (
  serialized: Person_person_allApplications_CharityCareApplication_person_openApplicationsOrig
): Person_person_allApplications_CharityCareApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allApplications_CharityCareApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_CharityCareApplication_person_openApplications'
  )
}
export const serializePerson_person_allApplications_CharityCareApplication_person_openApplications = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_openApplications
): Person_person_allApplications_CharityCareApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allApplications_CharityCareApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_CharityCareApplication_person_openApplications'
  )
}
export interface Person_person_allApplications_CharityCareApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_allApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_allApplications_CharityCareApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_allApplications_CharityCareApplication_person_openHouseholdMemberApplications
): Person_person_allApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_CharityCareApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Person_person_allApplications_CharityCareApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Person_person_allApplications_CharityCareApplication_person_benefitOutcomes[]
  incomeSources: Person_person_allApplications_CharityCareApplication_person_incomeSources[]
  deductions: Person_person_allApplications_CharityCareApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  openApplications: Person_person_allApplications_CharityCareApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_allApplications_CharityCareApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_allApplications_CharityCareApplication_person = (
  serialized: Person_person_allApplications_CharityCareApplication_personOrig
): Person_person_allApplications_CharityCareApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allApplications_CharityCareApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allApplications_CharityCareApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allApplications_CharityCareApplication_person_deductions
  ),
  openApplications: serialized.openApplications.map(
    deserializePerson_person_allApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_allApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_allApplications_CharityCareApplication_person = (
  deserialized: Person_person_allApplications_CharityCareApplication_person
): Person_person_allApplications_CharityCareApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allApplications_CharityCareApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializePerson_person_allApplications_CharityCareApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allApplications_CharityCareApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allApplications_CharityCareApplication_person_deductions
  ),
  openApplications: deserialized.openApplications.map(
    serializePerson_person_allApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_allApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_allApplications_CharityCareApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializePerson_person_allApplications_CharityCareApplication_assignedTo = (
  serialized: Person_person_allApplications_CharityCareApplication_assignedToOrig
): Person_person_allApplications_CharityCareApplication_assignedTo => ({
  ...serialized,
})
export const serializePerson_person_allApplications_CharityCareApplication_assignedTo = (
  deserialized: Person_person_allApplications_CharityCareApplication_assignedTo
): Person_person_allApplications_CharityCareApplication_assignedToOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_CharityCareApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allApplications_CharityCareApplication_householdMembers_person = (
  serialized: Person_person_allApplications_CharityCareApplication_householdMembers_personOrig
): Person_person_allApplications_CharityCareApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_allApplications_CharityCareApplication_householdMembers_person = (
  deserialized: Person_person_allApplications_CharityCareApplication_householdMembers_person
): Person_person_allApplications_CharityCareApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_CharityCareApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: Person_person_allApplications_CharityCareApplication_householdMembers_person
}
export const deserializePerson_person_allApplications_CharityCareApplication_householdMembers = (
  serialized: Person_person_allApplications_CharityCareApplication_householdMembersOrig
): Person_person_allApplications_CharityCareApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_allApplications_CharityCareApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_allApplications_CharityCareApplication_householdMembers = (
  deserialized: Person_person_allApplications_CharityCareApplication_householdMembers
): Person_person_allApplications_CharityCareApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_allApplications_CharityCareApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_allApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  dateOfApplication: Date | null
  requestedDateOfApplication: Date | null
  notes: string | null
  facility: string
  coveragePeriod: number | null
  charityCareType: string
  person: Person_person_allApplications_CharityCareApplication_person
  assignedTo: Person_person_allApplications_CharityCareApplication_assignedTo | null
  householdMembers: Person_person_allApplications_CharityCareApplication_householdMembers[]
}
export const deserializePerson_person_allApplications_CharityCareApplication = (
  serialized: Person_person_allApplications_CharityCareApplicationOrig
): Person_person_allApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  requestedDateOfApplication:
    serialized.requestedDateOfApplication != null
      ? parseDate(serialized.requestedDateOfApplication)
      : serialized.requestedDateOfApplication,
  person: deserializePerson_person_allApplications_CharityCareApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializePerson_person_allApplications_CharityCareApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_allApplications_CharityCareApplication_householdMembers
  ),
})
export const serializePerson_person_allApplications_CharityCareApplication = (
  deserialized: Person_person_allApplications_CharityCareApplication
): Person_person_allApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  requestedDateOfApplication:
    deserialized.requestedDateOfApplication != null
      ? formatISODate(deserialized.requestedDateOfApplication)
      : deserialized.requestedDateOfApplication,
  person: serializePerson_person_allApplications_CharityCareApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializePerson_person_allApplications_CharityCareApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_allApplications_CharityCareApplication_householdMembers
  ),
})
export interface Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializePerson_person_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializePerson_person_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards
): Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializePerson_person_allApplications_SlideApplication_person_phoneNumbers_esignSession = (
  serialized: Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSessionOrig
): Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializePerson_person_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializePerson_person_allApplications_SlideApplication_person_phoneNumbers_esignSession = (
  deserialized: Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSession
): Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializePerson_person_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Person_person_allApplications_SlideApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Person_person_allApplications_SlideApplication_person_phoneNumbers_esignSession | null
}
export const deserializePerson_person_allApplications_SlideApplication_person_phoneNumbers = (
  serialized: Person_person_allApplications_SlideApplication_person_phoneNumbersOrig
): Person_person_allApplications_SlideApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializePerson_person_allApplications_SlideApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializePerson_person_allApplications_SlideApplication_person_phoneNumbers = (
  deserialized: Person_person_allApplications_SlideApplication_person_phoneNumbers
): Person_person_allApplications_SlideApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializePerson_person_allApplications_SlideApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication
): Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication
): Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplicationOrig
): Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication
): Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Person_person_allApplications_SlideApplication_person_benefitOutcomes_application =
  | Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication
  | Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication
  | Person_person_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication
export const deserializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application = (
  serialized: Person_person_allApplications_SlideApplication_person_benefitOutcomes_applicationOrig
): Person_person_allApplications_SlideApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_SlideApplication_person_benefitOutcomes_application'
  )
}
export const serializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application = (
  deserialized: Person_person_allApplications_SlideApplication_person_benefitOutcomes_application
): Person_person_allApplications_SlideApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_SlideApplication_person_benefitOutcomes_application'
  )
}
export interface Person_person_allApplications_SlideApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Person_person_allApplications_SlideApplication_person_benefitOutcomes_application | null
}
export const deserializePerson_person_allApplications_SlideApplication_person_benefitOutcomes = (
  serialized: Person_person_allApplications_SlideApplication_person_benefitOutcomesOrig
): Person_person_allApplications_SlideApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializePerson_person_allApplications_SlideApplication_person_benefitOutcomes = (
  deserialized: Person_person_allApplications_SlideApplication_person_benefitOutcomes
): Person_person_allApplications_SlideApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializePerson_person_allApplications_SlideApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Person_person_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializePerson_person_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: Person_person_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizardsOrig
): Person_person_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializePerson_person_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: Person_person_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards
): Person_person_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Person_person_allApplications_SlideApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Person_person_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializePerson_person_allApplications_SlideApplication_person_incomeSources_esignSession = (
  serialized: Person_person_allApplications_SlideApplication_person_incomeSources_esignSessionOrig
): Person_person_allApplications_SlideApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializePerson_person_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializePerson_person_allApplications_SlideApplication_person_incomeSources_esignSession = (
  deserialized: Person_person_allApplications_SlideApplication_person_incomeSources_esignSession
): Person_person_allApplications_SlideApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializePerson_person_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Person_person_allApplications_SlideApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Person_person_allApplications_SlideApplication_person_incomeSources_esignSession | null
}
export const deserializePerson_person_allApplications_SlideApplication_person_incomeSources = (
  serialized: Person_person_allApplications_SlideApplication_person_incomeSourcesOrig
): Person_person_allApplications_SlideApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializePerson_person_allApplications_SlideApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializePerson_person_allApplications_SlideApplication_person_incomeSources = (
  deserialized: Person_person_allApplications_SlideApplication_person_incomeSources
): Person_person_allApplications_SlideApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializePerson_person_allApplications_SlideApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Person_person_allApplications_SlideApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allApplications_SlideApplication_person_deductions = (
  serialized: Person_person_allApplications_SlideApplication_person_deductionsOrig
): Person_person_allApplications_SlideApplication_person_deductions => ({
  ...serialized,
})
export const serializePerson_person_allApplications_SlideApplication_person_deductions = (
  deserialized: Person_person_allApplications_SlideApplication_person_deductions
): Person_person_allApplications_SlideApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_SlideApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_allApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_allApplications_SlideApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_allApplications_SlideApplication_person_openApplications_MedicaidApplication
): Person_person_allApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_SlideApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_allApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_allApplications_SlideApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_allApplications_SlideApplication_person_openApplications_CharityCareApplication
): Person_person_allApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_SlideApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_SlideApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_allApplications_SlideApplication_person_openApplications_SlideApplicationOrig
): Person_person_allApplications_SlideApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_SlideApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_allApplications_SlideApplication_person_openApplications_SlideApplication
): Person_person_allApplications_SlideApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_allApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication
): Person_person_allApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_allApplications_SlideApplication_person_openApplications =
  | Person_person_allApplications_SlideApplication_person_openApplications_MedicaidApplication
  | Person_person_allApplications_SlideApplication_person_openApplications_CharityCareApplication
  | Person_person_allApplications_SlideApplication_person_openApplications_SlideApplication
  | Person_person_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_allApplications_SlideApplication_person_openApplications = (
  serialized: Person_person_allApplications_SlideApplication_person_openApplicationsOrig
): Person_person_allApplications_SlideApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_allApplications_SlideApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allApplications_SlideApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allApplications_SlideApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_SlideApplication_person_openApplications'
  )
}
export const serializePerson_person_allApplications_SlideApplication_person_openApplications = (
  deserialized: Person_person_allApplications_SlideApplication_person_openApplications
): Person_person_allApplications_SlideApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_allApplications_SlideApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allApplications_SlideApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allApplications_SlideApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_SlideApplication_person_openApplications'
  )
}
export interface Person_person_allApplications_SlideApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allApplications_SlideApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_allApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_allApplications_SlideApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_SlideApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_allApplications_SlideApplication_person_openHouseholdMemberApplications
): Person_person_allApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_SlideApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Person_person_allApplications_SlideApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Person_person_allApplications_SlideApplication_person_benefitOutcomes[]
  incomeSources: Person_person_allApplications_SlideApplication_person_incomeSources[]
  deductions: Person_person_allApplications_SlideApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  openApplications: Person_person_allApplications_SlideApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_allApplications_SlideApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_allApplications_SlideApplication_person = (
  serialized: Person_person_allApplications_SlideApplication_personOrig
): Person_person_allApplications_SlideApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allApplications_SlideApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializePerson_person_allApplications_SlideApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allApplications_SlideApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allApplications_SlideApplication_person_deductions
  ),
  openApplications: serialized.openApplications.map(
    deserializePerson_person_allApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_allApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_allApplications_SlideApplication_person = (
  deserialized: Person_person_allApplications_SlideApplication_person
): Person_person_allApplications_SlideApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allApplications_SlideApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializePerson_person_allApplications_SlideApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allApplications_SlideApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allApplications_SlideApplication_person_deductions
  ),
  openApplications: deserialized.openApplications.map(
    serializePerson_person_allApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_allApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_allApplications_SlideApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializePerson_person_allApplications_SlideApplication_assignedTo = (
  serialized: Person_person_allApplications_SlideApplication_assignedToOrig
): Person_person_allApplications_SlideApplication_assignedTo => ({
  ...serialized,
})
export const serializePerson_person_allApplications_SlideApplication_assignedTo = (
  deserialized: Person_person_allApplications_SlideApplication_assignedTo
): Person_person_allApplications_SlideApplication_assignedToOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_SlideApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allApplications_SlideApplication_householdMembers_person = (
  serialized: Person_person_allApplications_SlideApplication_householdMembers_personOrig
): Person_person_allApplications_SlideApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_allApplications_SlideApplication_householdMembers_person = (
  deserialized: Person_person_allApplications_SlideApplication_householdMembers_person
): Person_person_allApplications_SlideApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_SlideApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: Person_person_allApplications_SlideApplication_householdMembers_person
}
export const deserializePerson_person_allApplications_SlideApplication_householdMembers = (
  serialized: Person_person_allApplications_SlideApplication_householdMembersOrig
): Person_person_allApplications_SlideApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_allApplications_SlideApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_allApplications_SlideApplication_householdMembers = (
  deserialized: Person_person_allApplications_SlideApplication_householdMembers
): Person_person_allApplications_SlideApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_allApplications_SlideApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_allApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  slideType: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: Person_person_allApplications_SlideApplication_person
  assignedTo: Person_person_allApplications_SlideApplication_assignedTo | null
  householdMembers: Person_person_allApplications_SlideApplication_householdMembers[]
}
export const deserializePerson_person_allApplications_SlideApplication = (
  serialized: Person_person_allApplications_SlideApplicationOrig
): Person_person_allApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  slideType: deserializeSlideType(serialized.slideType),
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializePerson_person_allApplications_SlideApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializePerson_person_allApplications_SlideApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_allApplications_SlideApplication_householdMembers
  ),
})
export const serializePerson_person_allApplications_SlideApplication = (
  deserialized: Person_person_allApplications_SlideApplication
): Person_person_allApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  slideType: serializeSlideType(deserialized.slideType),
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializePerson_person_allApplications_SlideApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializePerson_person_allApplications_SlideApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_allApplications_SlideApplication_householdMembers
  ),
})
export interface Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards
): Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSessionOrig
): Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializePerson_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession
): Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializePerson_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession | null
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_phoneNumbers = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_phoneNumbersOrig
): Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializePerson_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_phoneNumbers = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers
): Person_person_allApplications_RyanWhiteApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializePerson_person_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication
): Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication
): Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplicationOrig
): Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication
): Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application =
  | Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication
  | Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication
  | Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_applicationOrig
): Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application'
  )
}
export const serializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application
): Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application'
  )
}
export interface Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application | null
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomesOrig
): Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes
): Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizardsOrig
): Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards
): Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSessionOrig
): Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializePerson_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession
): Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializePerson_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Person_person_allApplications_RyanWhiteApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Person_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession | null
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_incomeSources = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_incomeSourcesOrig
): Person_person_allApplications_RyanWhiteApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializePerson_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_incomeSources = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_incomeSources
): Person_person_allApplications_RyanWhiteApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializePerson_person_allApplications_RyanWhiteApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Person_person_allApplications_RyanWhiteApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_deductions = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_deductionsOrig
): Person_person_allApplications_RyanWhiteApplication_person_deductions => ({
  ...serialized,
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_deductions = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_deductions
): Person_person_allApplications_RyanWhiteApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
): Person_person_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
): Person_person_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig
): Person_person_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication
): Person_person_allApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
): Person_person_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_allApplications_RyanWhiteApplication_person_openApplications =
  | Person_person_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
  | Person_person_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
  | Person_person_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication
  | Person_person_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_openApplications = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_openApplicationsOrig
): Person_person_allApplications_RyanWhiteApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_RyanWhiteApplication_person_openApplications'
  )
}
export const serializePerson_person_allApplications_RyanWhiteApplication_person_openApplications = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_openApplications
): Person_person_allApplications_RyanWhiteApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allApplications_RyanWhiteApplication_person_openApplications'
  )
}
export interface Person_person_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
): Person_person_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allApplications_RyanWhiteApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Person_person_allApplications_RyanWhiteApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Person_person_allApplications_RyanWhiteApplication_person_benefitOutcomes[]
  incomeSources: Person_person_allApplications_RyanWhiteApplication_person_incomeSources[]
  deductions: Person_person_allApplications_RyanWhiteApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  openApplications: Person_person_allApplications_RyanWhiteApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_person = (
  serialized: Person_person_allApplications_RyanWhiteApplication_personOrig
): Person_person_allApplications_RyanWhiteApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allApplications_RyanWhiteApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allApplications_RyanWhiteApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allApplications_RyanWhiteApplication_person_deductions
  ),
  openApplications: serialized.openApplications.map(
    deserializePerson_person_allApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_allApplications_RyanWhiteApplication_person = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_person
): Person_person_allApplications_RyanWhiteApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allApplications_RyanWhiteApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializePerson_person_allApplications_RyanWhiteApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allApplications_RyanWhiteApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allApplications_RyanWhiteApplication_person_deductions
  ),
  openApplications: deserialized.openApplications.map(
    serializePerson_person_allApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_allApplications_RyanWhiteApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_assignedTo = (
  serialized: Person_person_allApplications_RyanWhiteApplication_assignedToOrig
): Person_person_allApplications_RyanWhiteApplication_assignedTo => ({
  ...serialized,
})
export const serializePerson_person_allApplications_RyanWhiteApplication_assignedTo = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_assignedTo
): Person_person_allApplications_RyanWhiteApplication_assignedToOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_RyanWhiteApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_householdMembers_person = (
  serialized: Person_person_allApplications_RyanWhiteApplication_householdMembers_personOrig
): Person_person_allApplications_RyanWhiteApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_allApplications_RyanWhiteApplication_householdMembers_person = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_householdMembers_person
): Person_person_allApplications_RyanWhiteApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_allApplications_RyanWhiteApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: Person_person_allApplications_RyanWhiteApplication_householdMembers_person
}
export const deserializePerson_person_allApplications_RyanWhiteApplication_householdMembers = (
  serialized: Person_person_allApplications_RyanWhiteApplication_householdMembersOrig
): Person_person_allApplications_RyanWhiteApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_allApplications_RyanWhiteApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_allApplications_RyanWhiteApplication_householdMembers = (
  deserialized: Person_person_allApplications_RyanWhiteApplication_householdMembers
): Person_person_allApplications_RyanWhiteApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_allApplications_RyanWhiteApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_allApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: Person_person_allApplications_RyanWhiteApplication_person
  assignedTo: Person_person_allApplications_RyanWhiteApplication_assignedTo | null
  householdMembers: Person_person_allApplications_RyanWhiteApplication_householdMembers[]
}
export const deserializePerson_person_allApplications_RyanWhiteApplication = (
  serialized: Person_person_allApplications_RyanWhiteApplicationOrig
): Person_person_allApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializePerson_person_allApplications_RyanWhiteApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializePerson_person_allApplications_RyanWhiteApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_allApplications_RyanWhiteApplication_householdMembers
  ),
})
export const serializePerson_person_allApplications_RyanWhiteApplication = (
  deserialized: Person_person_allApplications_RyanWhiteApplication
): Person_person_allApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializePerson_person_allApplications_RyanWhiteApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializePerson_person_allApplications_RyanWhiteApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_allApplications_RyanWhiteApplication_householdMembers
  ),
})
export type Person_person_allApplications =
  | Person_person_allApplications_MedicaidApplication
  | Person_person_allApplications_MonitorApplication
  | Person_person_allApplications_CharityCareApplication
  | Person_person_allApplications_SlideApplication
  | Person_person_allApplications_RyanWhiteApplication
export const deserializePerson_person_allApplications = (
  serialized: Person_person_allApplicationsOrig
): Person_person_allApplications => {
  if (false || serialized.__typename === 'MedicaidApplication')
    return deserializePerson_person_allApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'MonitorApplication')
    return deserializePerson_person_allApplications_MonitorApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allApplications_SlideApplication(serialized)
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_allApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` + 'Person_person_allApplications'
  )
}
export const serializePerson_person_allApplications = (
  deserialized: Person_person_allApplications
): Person_person_allApplicationsOrig => {
  if (false || deserialized.__typename === 'MedicaidApplication')
    return serializePerson_person_allApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'MonitorApplication')
    return serializePerson_person_allApplications_MonitorApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allApplications_SlideApplication(deserialized)
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_allApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` + 'Person_person_allApplications'
  )
}
export interface Person_person_openApplications_MedicaidApplication_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializePerson_person_openApplications_MedicaidApplication_eligibilityDeterminations = (
  serialized: Person_person_openApplications_MedicaidApplication_eligibilityDeterminationsOrig
): Person_person_openApplications_MedicaidApplication_eligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializePerson_person_openApplications_MedicaidApplication_eligibilityDeterminations = (
  deserialized: Person_person_openApplications_MedicaidApplication_eligibilityDeterminations
): Person_person_openApplications_MedicaidApplication_eligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface Person_person_openApplications_MedicaidApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_openApplications_MedicaidApplication_householdMembers_person = (
  serialized: Person_person_openApplications_MedicaidApplication_householdMembers_personOrig
): Person_person_openApplications_MedicaidApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_openApplications_MedicaidApplication_householdMembers_person = (
  deserialized: Person_person_openApplications_MedicaidApplication_householdMembers_person
): Person_person_openApplications_MedicaidApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_MedicaidApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: Person_person_openApplications_MedicaidApplication_householdMembers_person
}
export const deserializePerson_person_openApplications_MedicaidApplication_householdMembers = (
  serialized: Person_person_openApplications_MedicaidApplication_householdMembersOrig
): Person_person_openApplications_MedicaidApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_openApplications_MedicaidApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_openApplications_MedicaidApplication_householdMembers = (
  deserialized: Person_person_openApplications_MedicaidApplication_householdMembers
): Person_person_openApplications_MedicaidApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_openApplications_MedicaidApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_openApplications_MedicaidApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializePerson_person_openApplications_MedicaidApplication_documents_files = (
  serialized: Person_person_openApplications_MedicaidApplication_documents_filesOrig
): Person_person_openApplications_MedicaidApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializePerson_person_openApplications_MedicaidApplication_documents_files = (
  deserialized: Person_person_openApplications_MedicaidApplication_documents_files
): Person_person_openApplications_MedicaidApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Person_person_openApplications_MedicaidApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_openApplications_MedicaidApplication_documents_person = (
  serialized: Person_person_openApplications_MedicaidApplication_documents_personOrig
): Person_person_openApplications_MedicaidApplication_documents_person => ({
  ...serialized,
})
export const serializePerson_person_openApplications_MedicaidApplication_documents_person = (
  deserialized: Person_person_openApplications_MedicaidApplication_documents_person
): Person_person_openApplications_MedicaidApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_MedicaidApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializePerson_person_openApplications_MedicaidApplication_documents_application = (
  serialized: Person_person_openApplications_MedicaidApplication_documents_applicationOrig
): Person_person_openApplications_MedicaidApplication_documents_application => ({
  ...serialized,
})
export const serializePerson_person_openApplications_MedicaidApplication_documents_application = (
  deserialized: Person_person_openApplications_MedicaidApplication_documents_application
): Person_person_openApplications_MedicaidApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_MedicaidApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Person_person_openApplications_MedicaidApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Person_person_openApplications_MedicaidApplication_documents_person | null
  application: Person_person_openApplications_MedicaidApplication_documents_application
}
export const deserializePerson_person_openApplications_MedicaidApplication_documents = (
  serialized: Person_person_openApplications_MedicaidApplication_documentsOrig
): Person_person_openApplications_MedicaidApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializePerson_person_openApplications_MedicaidApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializePerson_person_openApplications_MedicaidApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializePerson_person_openApplications_MedicaidApplication_documents_application(
    serialized.application
  ),
})
export const serializePerson_person_openApplications_MedicaidApplication_documents = (
  deserialized: Person_person_openApplications_MedicaidApplication_documents
): Person_person_openApplications_MedicaidApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializePerson_person_openApplications_MedicaidApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializePerson_person_openApplications_MedicaidApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializePerson_person_openApplications_MedicaidApplication_documents_application(
    deserialized.application
  ),
})
export interface Person_person_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication
): Person_person_openApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication
): Person_person_openApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_MedicaidApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig
): Person_person_openApplications_MedicaidApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openApplications_MedicaidApplication_person_openApplications_SlideApplication
): Person_person_openApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
): Person_person_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openApplications_MedicaidApplication_person_openApplications =
  | Person_person_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication
  | Person_person_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication
  | Person_person_openApplications_MedicaidApplication_person_openApplications_SlideApplication
  | Person_person_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openApplications_MedicaidApplication_person_openApplications = (
  serialized: Person_person_openApplications_MedicaidApplication_person_openApplicationsOrig
): Person_person_openApplications_MedicaidApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openApplications_MedicaidApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openApplications_MedicaidApplication_person_openApplications'
  )
}
export const serializePerson_person_openApplications_MedicaidApplication_person_openApplications = (
  deserialized: Person_person_openApplications_MedicaidApplication_person_openApplications
): Person_person_openApplications_MedicaidApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openApplications_MedicaidApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openApplications_MedicaidApplication_person_openApplications'
  )
}
export interface Person_person_openApplications_MedicaidApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openApplications_MedicaidApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openApplications_MedicaidApplication_person_openHouseholdMemberApplications
): Person_person_openApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_MedicaidApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openApplications_MedicaidApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openApplications_MedicaidApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openApplications_MedicaidApplication_person = (
  serialized: Person_person_openApplications_MedicaidApplication_personOrig
): Person_person_openApplications_MedicaidApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openApplications_MedicaidApplication_person = (
  deserialized: Person_person_openApplications_MedicaidApplication_person
): Person_person_openApplications_MedicaidApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  initialDateOfService: Date | null
  mcdType: string
  mcdSubtype: string | null
  eligibilityDeterminations: Person_person_openApplications_MedicaidApplication_eligibilityDeterminations[]
  householdMembers: Person_person_openApplications_MedicaidApplication_householdMembers[]
  documents: Person_person_openApplications_MedicaidApplication_documents[]
  person: Person_person_openApplications_MedicaidApplication_person
}
export const deserializePerson_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openApplications_MedicaidApplicationOrig
): Person_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  mcdType: deserializeMcdType(serialized.mcdType),
  mcdSubtype:
    serialized.mcdSubtype != null
      ? deserializeMcdSubtype(serialized.mcdSubtype)
      : serialized.mcdSubtype,
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializePerson_person_openApplications_MedicaidApplication_eligibilityDeterminations
  ),
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_openApplications_MedicaidApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializePerson_person_openApplications_MedicaidApplication_documents
  ),
  person: deserializePerson_person_openApplications_MedicaidApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openApplications_MedicaidApplication
): Person_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  mcdType: serializeMcdType(deserialized.mcdType),
  mcdSubtype:
    deserialized.mcdSubtype != null
      ? serializeMcdSubtype(deserialized.mcdSubtype)
      : deserialized.mcdSubtype,
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializePerson_person_openApplications_MedicaidApplication_eligibilityDeterminations
  ),
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_openApplications_MedicaidApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializePerson_person_openApplications_MedicaidApplication_documents
  ),
  person: serializePerson_person_openApplications_MedicaidApplication_person(
    deserialized.person
  ),
})
export interface Person_person_openApplications_MonitorApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_openApplications_MonitorApplication_primaryPointOfContact = (
  serialized: Person_person_openApplications_MonitorApplication_primaryPointOfContactOrig
): Person_person_openApplications_MonitorApplication_primaryPointOfContact => ({
  ...serialized,
})
export const serializePerson_person_openApplications_MonitorApplication_primaryPointOfContact = (
  deserialized: Person_person_openApplications_MonitorApplication_primaryPointOfContact
): Person_person_openApplications_MonitorApplication_primaryPointOfContactOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_MonitorApplication_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializePerson_person_openApplications_MonitorApplication_eligibilityDeterminations = (
  serialized: Person_person_openApplications_MonitorApplication_eligibilityDeterminationsOrig
): Person_person_openApplications_MonitorApplication_eligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializePerson_person_openApplications_MonitorApplication_eligibilityDeterminations = (
  deserialized: Person_person_openApplications_MonitorApplication_eligibilityDeterminations
): Person_person_openApplications_MonitorApplication_eligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface Person_person_openApplications_MonitorApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_openApplications_MonitorApplication_householdMembers_person = (
  serialized: Person_person_openApplications_MonitorApplication_householdMembers_personOrig
): Person_person_openApplications_MonitorApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_openApplications_MonitorApplication_householdMembers_person = (
  deserialized: Person_person_openApplications_MonitorApplication_householdMembers_person
): Person_person_openApplications_MonitorApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_MonitorApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: Person_person_openApplications_MonitorApplication_householdMembers_person
}
export const deserializePerson_person_openApplications_MonitorApplication_householdMembers = (
  serialized: Person_person_openApplications_MonitorApplication_householdMembersOrig
): Person_person_openApplications_MonitorApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_openApplications_MonitorApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_openApplications_MonitorApplication_householdMembers = (
  deserialized: Person_person_openApplications_MonitorApplication_householdMembers
): Person_person_openApplications_MonitorApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_openApplications_MonitorApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_openApplications_MonitorApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializePerson_person_openApplications_MonitorApplication_documents_files = (
  serialized: Person_person_openApplications_MonitorApplication_documents_filesOrig
): Person_person_openApplications_MonitorApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializePerson_person_openApplications_MonitorApplication_documents_files = (
  deserialized: Person_person_openApplications_MonitorApplication_documents_files
): Person_person_openApplications_MonitorApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Person_person_openApplications_MonitorApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_openApplications_MonitorApplication_documents_person = (
  serialized: Person_person_openApplications_MonitorApplication_documents_personOrig
): Person_person_openApplications_MonitorApplication_documents_person => ({
  ...serialized,
})
export const serializePerson_person_openApplications_MonitorApplication_documents_person = (
  deserialized: Person_person_openApplications_MonitorApplication_documents_person
): Person_person_openApplications_MonitorApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_MonitorApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializePerson_person_openApplications_MonitorApplication_documents_application = (
  serialized: Person_person_openApplications_MonitorApplication_documents_applicationOrig
): Person_person_openApplications_MonitorApplication_documents_application => ({
  ...serialized,
})
export const serializePerson_person_openApplications_MonitorApplication_documents_application = (
  deserialized: Person_person_openApplications_MonitorApplication_documents_application
): Person_person_openApplications_MonitorApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_MonitorApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Person_person_openApplications_MonitorApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Person_person_openApplications_MonitorApplication_documents_person | null
  application: Person_person_openApplications_MonitorApplication_documents_application
}
export const deserializePerson_person_openApplications_MonitorApplication_documents = (
  serialized: Person_person_openApplications_MonitorApplication_documentsOrig
): Person_person_openApplications_MonitorApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializePerson_person_openApplications_MonitorApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializePerson_person_openApplications_MonitorApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializePerson_person_openApplications_MonitorApplication_documents_application(
    serialized.application
  ),
})
export const serializePerson_person_openApplications_MonitorApplication_documents = (
  deserialized: Person_person_openApplications_MonitorApplication_documents
): Person_person_openApplications_MonitorApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializePerson_person_openApplications_MonitorApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializePerson_person_openApplications_MonitorApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializePerson_person_openApplications_MonitorApplication_documents_application(
    deserialized.application
  ),
})
export interface Person_person_openApplications_MonitorApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openApplications_MonitorApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openApplications_MonitorApplication_person_openApplications_MedicaidApplication
): Person_person_openApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_MonitorApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openApplications_MonitorApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openApplications_MonitorApplication_person_openApplications_CharityCareApplication
): Person_person_openApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_MonitorApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_MonitorApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openApplications_MonitorApplication_person_openApplications_SlideApplicationOrig
): Person_person_openApplications_MonitorApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_MonitorApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openApplications_MonitorApplication_person_openApplications_SlideApplication
): Person_person_openApplications_MonitorApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
): Person_person_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openApplications_MonitorApplication_person_openApplications =
  | Person_person_openApplications_MonitorApplication_person_openApplications_MedicaidApplication
  | Person_person_openApplications_MonitorApplication_person_openApplications_CharityCareApplication
  | Person_person_openApplications_MonitorApplication_person_openApplications_SlideApplication
  | Person_person_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openApplications_MonitorApplication_person_openApplications = (
  serialized: Person_person_openApplications_MonitorApplication_person_openApplicationsOrig
): Person_person_openApplications_MonitorApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openApplications_MonitorApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openApplications_MonitorApplication_person_openApplications'
  )
}
export const serializePerson_person_openApplications_MonitorApplication_person_openApplications = (
  deserialized: Person_person_openApplications_MonitorApplication_person_openApplications
): Person_person_openApplications_MonitorApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openApplications_MonitorApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openApplications_MonitorApplication_person_openApplications'
  )
}
export interface Person_person_openApplications_MonitorApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openApplications_MonitorApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openApplications_MonitorApplication_person_openHouseholdMemberApplications
): Person_person_openApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_MonitorApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openApplications_MonitorApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openApplications_MonitorApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openApplications_MonitorApplication_person = (
  serialized: Person_person_openApplications_MonitorApplication_personOrig
): Person_person_openApplications_MonitorApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openApplications_MonitorApplication_person = (
  deserialized: Person_person_openApplications_MonitorApplication_person
): Person_person_openApplications_MonitorApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openApplications_MonitorApplication {
  __typename: 'MonitorApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  applicationType: string | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  darSubmitDate: Date | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  primaryPointOfContact: Person_person_openApplications_MonitorApplication_primaryPointOfContact | null
  initialDateOfService: Date | null
  eligibilityDeterminations: Person_person_openApplications_MonitorApplication_eligibilityDeterminations[]
  householdMembers: Person_person_openApplications_MonitorApplication_householdMembers[]
  documents: Person_person_openApplications_MonitorApplication_documents[]
  person: Person_person_openApplications_MonitorApplication_person
}
export const deserializePerson_person_openApplications_MonitorApplication = (
  serialized: Person_person_openApplications_MonitorApplicationOrig
): Person_person_openApplications_MonitorApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  darSubmitDate:
    serialized.darSubmitDate != null
      ? parseDate(serialized.darSubmitDate)
      : serialized.darSubmitDate,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializePerson_person_openApplications_MonitorApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializePerson_person_openApplications_MonitorApplication_eligibilityDeterminations
  ),
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_openApplications_MonitorApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializePerson_person_openApplications_MonitorApplication_documents
  ),
  person: deserializePerson_person_openApplications_MonitorApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openApplications_MonitorApplication = (
  deserialized: Person_person_openApplications_MonitorApplication
): Person_person_openApplications_MonitorApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  darSubmitDate:
    deserialized.darSubmitDate != null
      ? formatISODate(deserialized.darSubmitDate)
      : deserialized.darSubmitDate,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializePerson_person_openApplications_MonitorApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializePerson_person_openApplications_MonitorApplication_eligibilityDeterminations
  ),
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_openApplications_MonitorApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializePerson_person_openApplications_MonitorApplication_documents
  ),
  person: serializePerson_person_openApplications_MonitorApplication_person(
    deserialized.person
  ),
})
export interface Person_person_openApplications_CharityCareApplication_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializePerson_person_openApplications_CharityCareApplication_eligibilityDeterminations = (
  serialized: Person_person_openApplications_CharityCareApplication_eligibilityDeterminationsOrig
): Person_person_openApplications_CharityCareApplication_eligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializePerson_person_openApplications_CharityCareApplication_eligibilityDeterminations = (
  deserialized: Person_person_openApplications_CharityCareApplication_eligibilityDeterminations
): Person_person_openApplications_CharityCareApplication_eligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface Person_person_openApplications_CharityCareApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_openApplications_CharityCareApplication_householdMembers_person = (
  serialized: Person_person_openApplications_CharityCareApplication_householdMembers_personOrig
): Person_person_openApplications_CharityCareApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_openApplications_CharityCareApplication_householdMembers_person = (
  deserialized: Person_person_openApplications_CharityCareApplication_householdMembers_person
): Person_person_openApplications_CharityCareApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_CharityCareApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: Person_person_openApplications_CharityCareApplication_householdMembers_person
}
export const deserializePerson_person_openApplications_CharityCareApplication_householdMembers = (
  serialized: Person_person_openApplications_CharityCareApplication_householdMembersOrig
): Person_person_openApplications_CharityCareApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_openApplications_CharityCareApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_openApplications_CharityCareApplication_householdMembers = (
  deserialized: Person_person_openApplications_CharityCareApplication_householdMembers
): Person_person_openApplications_CharityCareApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_openApplications_CharityCareApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_openApplications_CharityCareApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializePerson_person_openApplications_CharityCareApplication_documents_files = (
  serialized: Person_person_openApplications_CharityCareApplication_documents_filesOrig
): Person_person_openApplications_CharityCareApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializePerson_person_openApplications_CharityCareApplication_documents_files = (
  deserialized: Person_person_openApplications_CharityCareApplication_documents_files
): Person_person_openApplications_CharityCareApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Person_person_openApplications_CharityCareApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_openApplications_CharityCareApplication_documents_person = (
  serialized: Person_person_openApplications_CharityCareApplication_documents_personOrig
): Person_person_openApplications_CharityCareApplication_documents_person => ({
  ...serialized,
})
export const serializePerson_person_openApplications_CharityCareApplication_documents_person = (
  deserialized: Person_person_openApplications_CharityCareApplication_documents_person
): Person_person_openApplications_CharityCareApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_CharityCareApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializePerson_person_openApplications_CharityCareApplication_documents_application = (
  serialized: Person_person_openApplications_CharityCareApplication_documents_applicationOrig
): Person_person_openApplications_CharityCareApplication_documents_application => ({
  ...serialized,
})
export const serializePerson_person_openApplications_CharityCareApplication_documents_application = (
  deserialized: Person_person_openApplications_CharityCareApplication_documents_application
): Person_person_openApplications_CharityCareApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_CharityCareApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Person_person_openApplications_CharityCareApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Person_person_openApplications_CharityCareApplication_documents_person | null
  application: Person_person_openApplications_CharityCareApplication_documents_application
}
export const deserializePerson_person_openApplications_CharityCareApplication_documents = (
  serialized: Person_person_openApplications_CharityCareApplication_documentsOrig
): Person_person_openApplications_CharityCareApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializePerson_person_openApplications_CharityCareApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializePerson_person_openApplications_CharityCareApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializePerson_person_openApplications_CharityCareApplication_documents_application(
    serialized.application
  ),
})
export const serializePerson_person_openApplications_CharityCareApplication_documents = (
  deserialized: Person_person_openApplications_CharityCareApplication_documents
): Person_person_openApplications_CharityCareApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializePerson_person_openApplications_CharityCareApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializePerson_person_openApplications_CharityCareApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializePerson_person_openApplications_CharityCareApplication_documents_application(
    deserialized.application
  ),
})
export interface Person_person_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication
): Person_person_openApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication
): Person_person_openApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_CharityCareApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig
): Person_person_openApplications_CharityCareApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openApplications_CharityCareApplication_person_openApplications_SlideApplication
): Person_person_openApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
): Person_person_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openApplications_CharityCareApplication_person_openApplications =
  | Person_person_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication
  | Person_person_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication
  | Person_person_openApplications_CharityCareApplication_person_openApplications_SlideApplication
  | Person_person_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openApplications_CharityCareApplication_person_openApplications = (
  serialized: Person_person_openApplications_CharityCareApplication_person_openApplicationsOrig
): Person_person_openApplications_CharityCareApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openApplications_CharityCareApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openApplications_CharityCareApplication_person_openApplications'
  )
}
export const serializePerson_person_openApplications_CharityCareApplication_person_openApplications = (
  deserialized: Person_person_openApplications_CharityCareApplication_person_openApplications
): Person_person_openApplications_CharityCareApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openApplications_CharityCareApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openApplications_CharityCareApplication_person_openApplications'
  )
}
export interface Person_person_openApplications_CharityCareApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openApplications_CharityCareApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openApplications_CharityCareApplication_person_openHouseholdMemberApplications
): Person_person_openApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_CharityCareApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openApplications_CharityCareApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openApplications_CharityCareApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openApplications_CharityCareApplication_person = (
  serialized: Person_person_openApplications_CharityCareApplication_personOrig
): Person_person_openApplications_CharityCareApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openApplications_CharityCareApplication_person = (
  deserialized: Person_person_openApplications_CharityCareApplication_person
): Person_person_openApplications_CharityCareApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  dateOfApplication: Date | null
  requestedDateOfApplication: Date | null
  notes: string | null
  facility: string
  coveragePeriod: number | null
  charityCareType: string
  eligibilityDeterminations: Person_person_openApplications_CharityCareApplication_eligibilityDeterminations[]
  householdMembers: Person_person_openApplications_CharityCareApplication_householdMembers[]
  documents: Person_person_openApplications_CharityCareApplication_documents[]
  person: Person_person_openApplications_CharityCareApplication_person
}
export const deserializePerson_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openApplications_CharityCareApplicationOrig
): Person_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  requestedDateOfApplication:
    serialized.requestedDateOfApplication != null
      ? parseDate(serialized.requestedDateOfApplication)
      : serialized.requestedDateOfApplication,
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializePerson_person_openApplications_CharityCareApplication_eligibilityDeterminations
  ),
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_openApplications_CharityCareApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializePerson_person_openApplications_CharityCareApplication_documents
  ),
  person: deserializePerson_person_openApplications_CharityCareApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openApplications_CharityCareApplication
): Person_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  requestedDateOfApplication:
    deserialized.requestedDateOfApplication != null
      ? formatISODate(deserialized.requestedDateOfApplication)
      : deserialized.requestedDateOfApplication,
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializePerson_person_openApplications_CharityCareApplication_eligibilityDeterminations
  ),
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_openApplications_CharityCareApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializePerson_person_openApplications_CharityCareApplication_documents
  ),
  person: serializePerson_person_openApplications_CharityCareApplication_person(
    deserialized.person
  ),
})
export interface Person_person_openApplications_SlideApplication_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializePerson_person_openApplications_SlideApplication_eligibilityDeterminations = (
  serialized: Person_person_openApplications_SlideApplication_eligibilityDeterminationsOrig
): Person_person_openApplications_SlideApplication_eligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializePerson_person_openApplications_SlideApplication_eligibilityDeterminations = (
  deserialized: Person_person_openApplications_SlideApplication_eligibilityDeterminations
): Person_person_openApplications_SlideApplication_eligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface Person_person_openApplications_SlideApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_openApplications_SlideApplication_householdMembers_person = (
  serialized: Person_person_openApplications_SlideApplication_householdMembers_personOrig
): Person_person_openApplications_SlideApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_openApplications_SlideApplication_householdMembers_person = (
  deserialized: Person_person_openApplications_SlideApplication_householdMembers_person
): Person_person_openApplications_SlideApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_SlideApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: Person_person_openApplications_SlideApplication_householdMembers_person
}
export const deserializePerson_person_openApplications_SlideApplication_householdMembers = (
  serialized: Person_person_openApplications_SlideApplication_householdMembersOrig
): Person_person_openApplications_SlideApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_openApplications_SlideApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_openApplications_SlideApplication_householdMembers = (
  deserialized: Person_person_openApplications_SlideApplication_householdMembers
): Person_person_openApplications_SlideApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_openApplications_SlideApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_openApplications_SlideApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializePerson_person_openApplications_SlideApplication_documents_files = (
  serialized: Person_person_openApplications_SlideApplication_documents_filesOrig
): Person_person_openApplications_SlideApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializePerson_person_openApplications_SlideApplication_documents_files = (
  deserialized: Person_person_openApplications_SlideApplication_documents_files
): Person_person_openApplications_SlideApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Person_person_openApplications_SlideApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_openApplications_SlideApplication_documents_person = (
  serialized: Person_person_openApplications_SlideApplication_documents_personOrig
): Person_person_openApplications_SlideApplication_documents_person => ({
  ...serialized,
})
export const serializePerson_person_openApplications_SlideApplication_documents_person = (
  deserialized: Person_person_openApplications_SlideApplication_documents_person
): Person_person_openApplications_SlideApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_SlideApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializePerson_person_openApplications_SlideApplication_documents_application = (
  serialized: Person_person_openApplications_SlideApplication_documents_applicationOrig
): Person_person_openApplications_SlideApplication_documents_application => ({
  ...serialized,
})
export const serializePerson_person_openApplications_SlideApplication_documents_application = (
  deserialized: Person_person_openApplications_SlideApplication_documents_application
): Person_person_openApplications_SlideApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_SlideApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Person_person_openApplications_SlideApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Person_person_openApplications_SlideApplication_documents_person | null
  application: Person_person_openApplications_SlideApplication_documents_application
}
export const deserializePerson_person_openApplications_SlideApplication_documents = (
  serialized: Person_person_openApplications_SlideApplication_documentsOrig
): Person_person_openApplications_SlideApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializePerson_person_openApplications_SlideApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializePerson_person_openApplications_SlideApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializePerson_person_openApplications_SlideApplication_documents_application(
    serialized.application
  ),
})
export const serializePerson_person_openApplications_SlideApplication_documents = (
  deserialized: Person_person_openApplications_SlideApplication_documents
): Person_person_openApplications_SlideApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializePerson_person_openApplications_SlideApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializePerson_person_openApplications_SlideApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializePerson_person_openApplications_SlideApplication_documents_application(
    deserialized.application
  ),
})
export interface Person_person_openApplications_SlideApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openApplications_SlideApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openApplications_SlideApplication_person_openApplications_MedicaidApplication
): Person_person_openApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_SlideApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openApplications_SlideApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openApplications_SlideApplication_person_openApplications_CharityCareApplication
): Person_person_openApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_SlideApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_SlideApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openApplications_SlideApplication_person_openApplications_SlideApplicationOrig
): Person_person_openApplications_SlideApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_SlideApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openApplications_SlideApplication_person_openApplications_SlideApplication
): Person_person_openApplications_SlideApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication
): Person_person_openApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openApplications_SlideApplication_person_openApplications =
  | Person_person_openApplications_SlideApplication_person_openApplications_MedicaidApplication
  | Person_person_openApplications_SlideApplication_person_openApplications_CharityCareApplication
  | Person_person_openApplications_SlideApplication_person_openApplications_SlideApplication
  | Person_person_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openApplications_SlideApplication_person_openApplications = (
  serialized: Person_person_openApplications_SlideApplication_person_openApplicationsOrig
): Person_person_openApplications_SlideApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openApplications_SlideApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openApplications_SlideApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openApplications_SlideApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openApplications_SlideApplication_person_openApplications'
  )
}
export const serializePerson_person_openApplications_SlideApplication_person_openApplications = (
  deserialized: Person_person_openApplications_SlideApplication_person_openApplications
): Person_person_openApplications_SlideApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openApplications_SlideApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openApplications_SlideApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openApplications_SlideApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openApplications_SlideApplication_person_openApplications'
  )
}
export interface Person_person_openApplications_SlideApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openApplications_SlideApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openApplications_SlideApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_SlideApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openApplications_SlideApplication_person_openHouseholdMemberApplications
): Person_person_openApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_SlideApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openApplications_SlideApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openApplications_SlideApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openApplications_SlideApplication_person = (
  serialized: Person_person_openApplications_SlideApplication_personOrig
): Person_person_openApplications_SlideApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openApplications_SlideApplication_person = (
  deserialized: Person_person_openApplications_SlideApplication_person
): Person_person_openApplications_SlideApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  slideType: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  eligibilityDeterminations: Person_person_openApplications_SlideApplication_eligibilityDeterminations[]
  householdMembers: Person_person_openApplications_SlideApplication_householdMembers[]
  documents: Person_person_openApplications_SlideApplication_documents[]
  person: Person_person_openApplications_SlideApplication_person
}
export const deserializePerson_person_openApplications_SlideApplication = (
  serialized: Person_person_openApplications_SlideApplicationOrig
): Person_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  slideType: deserializeSlideType(serialized.slideType),
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializePerson_person_openApplications_SlideApplication_eligibilityDeterminations
  ),
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_openApplications_SlideApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializePerson_person_openApplications_SlideApplication_documents
  ),
  person: deserializePerson_person_openApplications_SlideApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openApplications_SlideApplication = (
  deserialized: Person_person_openApplications_SlideApplication
): Person_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  slideType: serializeSlideType(deserialized.slideType),
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializePerson_person_openApplications_SlideApplication_eligibilityDeterminations
  ),
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_openApplications_SlideApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializePerson_person_openApplications_SlideApplication_documents
  ),
  person: serializePerson_person_openApplications_SlideApplication_person(
    deserialized.person
  ),
})
export interface Person_person_openApplications_RyanWhiteApplication_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializePerson_person_openApplications_RyanWhiteApplication_eligibilityDeterminations = (
  serialized: Person_person_openApplications_RyanWhiteApplication_eligibilityDeterminationsOrig
): Person_person_openApplications_RyanWhiteApplication_eligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializePerson_person_openApplications_RyanWhiteApplication_eligibilityDeterminations = (
  deserialized: Person_person_openApplications_RyanWhiteApplication_eligibilityDeterminations
): Person_person_openApplications_RyanWhiteApplication_eligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface Person_person_openApplications_RyanWhiteApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_openApplications_RyanWhiteApplication_householdMembers_person = (
  serialized: Person_person_openApplications_RyanWhiteApplication_householdMembers_personOrig
): Person_person_openApplications_RyanWhiteApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_openApplications_RyanWhiteApplication_householdMembers_person = (
  deserialized: Person_person_openApplications_RyanWhiteApplication_householdMembers_person
): Person_person_openApplications_RyanWhiteApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_RyanWhiteApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: Person_person_openApplications_RyanWhiteApplication_householdMembers_person
}
export const deserializePerson_person_openApplications_RyanWhiteApplication_householdMembers = (
  serialized: Person_person_openApplications_RyanWhiteApplication_householdMembersOrig
): Person_person_openApplications_RyanWhiteApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_openApplications_RyanWhiteApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_openApplications_RyanWhiteApplication_householdMembers = (
  deserialized: Person_person_openApplications_RyanWhiteApplication_householdMembers
): Person_person_openApplications_RyanWhiteApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_openApplications_RyanWhiteApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_openApplications_RyanWhiteApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializePerson_person_openApplications_RyanWhiteApplication_documents_files = (
  serialized: Person_person_openApplications_RyanWhiteApplication_documents_filesOrig
): Person_person_openApplications_RyanWhiteApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializePerson_person_openApplications_RyanWhiteApplication_documents_files = (
  deserialized: Person_person_openApplications_RyanWhiteApplication_documents_files
): Person_person_openApplications_RyanWhiteApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Person_person_openApplications_RyanWhiteApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_openApplications_RyanWhiteApplication_documents_person = (
  serialized: Person_person_openApplications_RyanWhiteApplication_documents_personOrig
): Person_person_openApplications_RyanWhiteApplication_documents_person => ({
  ...serialized,
})
export const serializePerson_person_openApplications_RyanWhiteApplication_documents_person = (
  deserialized: Person_person_openApplications_RyanWhiteApplication_documents_person
): Person_person_openApplications_RyanWhiteApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_RyanWhiteApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializePerson_person_openApplications_RyanWhiteApplication_documents_application = (
  serialized: Person_person_openApplications_RyanWhiteApplication_documents_applicationOrig
): Person_person_openApplications_RyanWhiteApplication_documents_application => ({
  ...serialized,
})
export const serializePerson_person_openApplications_RyanWhiteApplication_documents_application = (
  deserialized: Person_person_openApplications_RyanWhiteApplication_documents_application
): Person_person_openApplications_RyanWhiteApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Person_person_openApplications_RyanWhiteApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Person_person_openApplications_RyanWhiteApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Person_person_openApplications_RyanWhiteApplication_documents_person | null
  application: Person_person_openApplications_RyanWhiteApplication_documents_application
}
export const deserializePerson_person_openApplications_RyanWhiteApplication_documents = (
  serialized: Person_person_openApplications_RyanWhiteApplication_documentsOrig
): Person_person_openApplications_RyanWhiteApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializePerson_person_openApplications_RyanWhiteApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializePerson_person_openApplications_RyanWhiteApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializePerson_person_openApplications_RyanWhiteApplication_documents_application(
    serialized.application
  ),
})
export const serializePerson_person_openApplications_RyanWhiteApplication_documents = (
  deserialized: Person_person_openApplications_RyanWhiteApplication_documents
): Person_person_openApplications_RyanWhiteApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializePerson_person_openApplications_RyanWhiteApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializePerson_person_openApplications_RyanWhiteApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializePerson_person_openApplications_RyanWhiteApplication_documents_application(
    deserialized.application
  ),
})
export interface Person_person_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
): Person_person_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
): Person_person_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig
): Person_person_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication
): Person_person_openApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
): Person_person_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openApplications_RyanWhiteApplication_person_openApplications =
  | Person_person_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
  | Person_person_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
  | Person_person_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication
  | Person_person_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openApplications_RyanWhiteApplication_person_openApplications = (
  serialized: Person_person_openApplications_RyanWhiteApplication_person_openApplicationsOrig
): Person_person_openApplications_RyanWhiteApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openApplications_RyanWhiteApplication_person_openApplications'
  )
}
export const serializePerson_person_openApplications_RyanWhiteApplication_person_openApplications = (
  deserialized: Person_person_openApplications_RyanWhiteApplication_person_openApplications
): Person_person_openApplications_RyanWhiteApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openApplications_RyanWhiteApplication_person_openApplications'
  )
}
export interface Person_person_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
): Person_person_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openApplications_RyanWhiteApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openApplications_RyanWhiteApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openApplications_RyanWhiteApplication_person = (
  serialized: Person_person_openApplications_RyanWhiteApplication_personOrig
): Person_person_openApplications_RyanWhiteApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openApplications_RyanWhiteApplication_person = (
  deserialized: Person_person_openApplications_RyanWhiteApplication_person
): Person_person_openApplications_RyanWhiteApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  eligibilityDeterminations: Person_person_openApplications_RyanWhiteApplication_eligibilityDeterminations[]
  householdMembers: Person_person_openApplications_RyanWhiteApplication_householdMembers[]
  documents: Person_person_openApplications_RyanWhiteApplication_documents[]
  person: Person_person_openApplications_RyanWhiteApplication_person
}
export const deserializePerson_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializePerson_person_openApplications_RyanWhiteApplication_eligibilityDeterminations
  ),
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_openApplications_RyanWhiteApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializePerson_person_openApplications_RyanWhiteApplication_documents
  ),
  person: deserializePerson_person_openApplications_RyanWhiteApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openApplications_RyanWhiteApplication
): Person_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializePerson_person_openApplications_RyanWhiteApplication_eligibilityDeterminations
  ),
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_openApplications_RyanWhiteApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializePerson_person_openApplications_RyanWhiteApplication_documents
  ),
  person: serializePerson_person_openApplications_RyanWhiteApplication_person(
    deserialized.person
  ),
})
export type Person_person_openApplications =
  | Person_person_openApplications_MedicaidApplication
  | Person_person_openApplications_MonitorApplication
  | Person_person_openApplications_CharityCareApplication
  | Person_person_openApplications_SlideApplication
  | Person_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openApplications = (
  serialized: Person_person_openApplicationsOrig
): Person_person_openApplications => {
  if (false || serialized.__typename === 'MedicaidApplication')
    return deserializePerson_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'MonitorApplication')
    return deserializePerson_person_openApplications_MonitorApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` + 'Person_person_openApplications'
  )
}
export const serializePerson_person_openApplications = (
  deserialized: Person_person_openApplications
): Person_person_openApplicationsOrig => {
  if (false || deserialized.__typename === 'MedicaidApplication')
    return serializePerson_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'MonitorApplication')
    return serializePerson_person_openApplications_MonitorApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` + 'Person_person_openApplications'
  )
}
export interface Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication
): Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication
): Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig
): Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication
): Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
): Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications =
  | Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication
  | Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication
  | Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication
  | Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications = (
  serialized: Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplicationsOrig
): Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications'
  )
}
export const serializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications = (
  deserialized: Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications
): Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications'
  )
}
export interface Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications
): Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_MedicaidApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person = (
  serialized: Person_person_openHouseholdMemberApplications_MedicaidApplication_personOrig
): Person_person_openHouseholdMemberApplications_MedicaidApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person = (
  deserialized: Person_person_openHouseholdMemberApplications_MedicaidApplication_person
): Person_person_openHouseholdMemberApplications_MedicaidApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openHouseholdMemberApplications_MedicaidApplication {
  __typename: 'MedicaidApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  initialDateOfService: Date | null
  mcdType: string
  mcdSubtype: string | null
  person: Person_person_openHouseholdMemberApplications_MedicaidApplication_person
}
export const deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication = (
  serialized: Person_person_openHouseholdMemberApplications_MedicaidApplicationOrig
): Person_person_openHouseholdMemberApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  mcdType: deserializeMcdType(serialized.mcdType),
  mcdSubtype:
    serialized.mcdSubtype != null
      ? deserializeMcdSubtype(serialized.mcdSubtype)
      : serialized.mcdSubtype,
  person: deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openHouseholdMemberApplications_MedicaidApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_MedicaidApplication
): Person_person_openHouseholdMemberApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  mcdType: serializeMcdType(deserialized.mcdType),
  mcdSubtype:
    deserialized.mcdSubtype != null
      ? serializeMcdSubtype(deserialized.mcdSubtype)
      : deserialized.mcdSubtype,
  person: serializePerson_person_openHouseholdMemberApplications_MedicaidApplication_person(
    deserialized.person
  ),
})
export interface Person_person_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact = (
  serialized: Person_person_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContactOrig
): Person_person_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact => ({
  ...serialized,
})
export const serializePerson_person_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact = (
  deserialized: Person_person_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact
): Person_person_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContactOrig => ({
  ...deserialized,
})
export interface Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication
): Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication
): Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplicationOrig
): Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication
): Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
): Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications =
  | Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication
  | Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication
  | Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication
  | Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications = (
  serialized: Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplicationsOrig
): Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications'
  )
}
export const serializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications = (
  deserialized: Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications
): Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications'
  )
}
export interface Person_person_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications
): Person_person_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_MonitorApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_person = (
  serialized: Person_person_openHouseholdMemberApplications_MonitorApplication_personOrig
): Person_person_openHouseholdMemberApplications_MonitorApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openHouseholdMemberApplications_MonitorApplication_person = (
  deserialized: Person_person_openHouseholdMemberApplications_MonitorApplication_person
): Person_person_openHouseholdMemberApplications_MonitorApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openHouseholdMemberApplications_MonitorApplication {
  __typename: 'MonitorApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  applicationType: string | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  darSubmitDate: Date | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  primaryPointOfContact: Person_person_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact | null
  initialDateOfService: Date | null
  person: Person_person_openHouseholdMemberApplications_MonitorApplication_person
}
export const deserializePerson_person_openHouseholdMemberApplications_MonitorApplication = (
  serialized: Person_person_openHouseholdMemberApplications_MonitorApplicationOrig
): Person_person_openHouseholdMemberApplications_MonitorApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  darSubmitDate:
    serialized.darSubmitDate != null
      ? parseDate(serialized.darSubmitDate)
      : serialized.darSubmitDate,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  person: deserializePerson_person_openHouseholdMemberApplications_MonitorApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openHouseholdMemberApplications_MonitorApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_MonitorApplication
): Person_person_openHouseholdMemberApplications_MonitorApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  darSubmitDate:
    deserialized.darSubmitDate != null
      ? formatISODate(deserialized.darSubmitDate)
      : deserialized.darSubmitDate,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializePerson_person_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  person: serializePerson_person_openHouseholdMemberApplications_MonitorApplication_person(
    deserialized.person
  ),
})
export interface Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication
): Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication
): Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig
): Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication
): Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
): Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications =
  | Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication
  | Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication
  | Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication
  | Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications = (
  serialized: Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplicationsOrig
): Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications'
  )
}
export const serializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications = (
  deserialized: Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications
): Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications'
  )
}
export interface Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications
): Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_CharityCareApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person = (
  serialized: Person_person_openHouseholdMemberApplications_CharityCareApplication_personOrig
): Person_person_openHouseholdMemberApplications_CharityCareApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person = (
  deserialized: Person_person_openHouseholdMemberApplications_CharityCareApplication_person
): Person_person_openHouseholdMemberApplications_CharityCareApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openHouseholdMemberApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  dateOfApplication: Date | null
  requestedDateOfApplication: Date | null
  notes: string | null
  facility: string
  coveragePeriod: number | null
  charityCareType: string
  person: Person_person_openHouseholdMemberApplications_CharityCareApplication_person
}
export const deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication = (
  serialized: Person_person_openHouseholdMemberApplications_CharityCareApplicationOrig
): Person_person_openHouseholdMemberApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  requestedDateOfApplication:
    serialized.requestedDateOfApplication != null
      ? parseDate(serialized.requestedDateOfApplication)
      : serialized.requestedDateOfApplication,
  person: deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openHouseholdMemberApplications_CharityCareApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_CharityCareApplication
): Person_person_openHouseholdMemberApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  requestedDateOfApplication:
    deserialized.requestedDateOfApplication != null
      ? formatISODate(deserialized.requestedDateOfApplication)
      : deserialized.requestedDateOfApplication,
  person: serializePerson_person_openHouseholdMemberApplications_CharityCareApplication_person(
    deserialized.person
  ),
})
export interface Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication
): Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication
): Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplicationOrig
): Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication
): Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication
): Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications =
  | Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication
  | Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication
  | Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication
  | Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications = (
  serialized: Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplicationsOrig
): Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications'
  )
}
export const serializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications = (
  deserialized: Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications
): Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications'
  )
}
export interface Person_person_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications
): Person_person_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_SlideApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openHouseholdMemberApplications_SlideApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openHouseholdMemberApplications_SlideApplication_person = (
  serialized: Person_person_openHouseholdMemberApplications_SlideApplication_personOrig
): Person_person_openHouseholdMemberApplications_SlideApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openHouseholdMemberApplications_SlideApplication_person = (
  deserialized: Person_person_openHouseholdMemberApplications_SlideApplication_person
): Person_person_openHouseholdMemberApplications_SlideApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openHouseholdMemberApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  slideType: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: Person_person_openHouseholdMemberApplications_SlideApplication_person
}
export const deserializePerson_person_openHouseholdMemberApplications_SlideApplication = (
  serialized: Person_person_openHouseholdMemberApplications_SlideApplicationOrig
): Person_person_openHouseholdMemberApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  slideType: deserializeSlideType(serialized.slideType),
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializePerson_person_openHouseholdMemberApplications_SlideApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openHouseholdMemberApplications_SlideApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_SlideApplication
): Person_person_openHouseholdMemberApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  slideType: serializeSlideType(deserialized.slideType),
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializePerson_person_openHouseholdMemberApplications_SlideApplication_person(
    deserialized.person
  ),
})
export interface Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications =
  | Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
  | Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
  | Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication
  | Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications = (
  serialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplicationsOrig
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications'
  )
}
export const serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications = (
  deserialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications'
  )
}
export interface Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person = (
  serialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_personOrig
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person = (
  deserialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openHouseholdMemberApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: Person_person_openHouseholdMemberApplications_RyanWhiteApplication_person
}
export const deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication = (
  serialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplicationOrig
): Person_person_openHouseholdMemberApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication = (
  deserialized: Person_person_openHouseholdMemberApplications_RyanWhiteApplication
): Person_person_openHouseholdMemberApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication_person(
    deserialized.person
  ),
})
export type Person_person_openHouseholdMemberApplications =
  | Person_person_openHouseholdMemberApplications_MedicaidApplication
  | Person_person_openHouseholdMemberApplications_MonitorApplication
  | Person_person_openHouseholdMemberApplications_CharityCareApplication
  | Person_person_openHouseholdMemberApplications_SlideApplication
  | Person_person_openHouseholdMemberApplications_RyanWhiteApplication
export const deserializePerson_person_openHouseholdMemberApplications = (
  serialized: Person_person_openHouseholdMemberApplicationsOrig
): Person_person_openHouseholdMemberApplications => {
  if (false || serialized.__typename === 'MedicaidApplication')
    return deserializePerson_person_openHouseholdMemberApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'MonitorApplication')
    return deserializePerson_person_openHouseholdMemberApplications_MonitorApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openHouseholdMemberApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openHouseholdMemberApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` + 'Person_person_openHouseholdMemberApplications'
  )
}
export const serializePerson_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openHouseholdMemberApplications
): Person_person_openHouseholdMemberApplicationsOrig => {
  if (false || deserialized.__typename === 'MedicaidApplication')
    return serializePerson_person_openHouseholdMemberApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'MonitorApplication')
    return serializePerson_person_openHouseholdMemberApplications_MonitorApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openHouseholdMemberApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openHouseholdMemberApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openHouseholdMemberApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` + 'Person_person_openHouseholdMemberApplications'
  )
}
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications =
  | Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication
  | Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication
  | Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication
  | Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplicationsOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications'
  )
}
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications'
  )
}
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbersOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbersOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSourcesOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSourcesOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductionsOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_assetsOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_assetsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbersOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSourcesOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductionsOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assetsOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assetsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources[]
  deductions: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions[]
  assets: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPersonOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions
  ),
  assets: serialized.assets.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions
  ),
  assets: deserialized.assets.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  otherPerson: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson
  liveTogether: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationshipsOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications[]
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources[]
  deductions: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions[]
  assets: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  relationships: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships[]
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_personOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions
  ),
  assets: serialized.assets.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  relationships: serialized.relationships.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions
  ),
  assets: deserialized.assets.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  relationships: deserialized.relationships.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_personOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembersOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_filesOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_personOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_applicationOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person | null
  application: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documentsOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application(
    serialized.application
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application(
    deserialized.application
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_MedicaidApplication {
  __typename: 'MedicaidApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  initialDateOfService: Date | null
  mcdType: string
  mcdSubtype: string | null
  person: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_person
  householdMembers: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers[]
  documents: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents[]
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  mcdType: deserializeMcdType(serialized.mcdType),
  mcdSubtype:
    serialized.mcdSubtype != null
      ? deserializeMcdSubtype(serialized.mcdSubtype)
      : serialized.mcdSubtype,
  person: deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person(
    serialized.person
  ),
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MedicaidApplication
): Person_person_allOpenHouseholdMemberApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  mcdType: serializeMcdType(deserialized.mcdType),
  mcdSubtype:
    deserialized.mcdSubtype != null
      ? serializeMcdSubtype(deserialized.mcdSubtype)
      : deserialized.mcdSubtype,
  person: serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_person(
    deserialized.person
  ),
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication_documents
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContactOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContactOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications =
  | Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication
  | Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication
  | Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication
  | Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplicationsOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications'
  )
}
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications'
  )
}
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbersOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbersOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSourcesOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSourcesOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_deductionsOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_assets = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_assetsOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_assets => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_assets = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_assets
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_assetsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbersOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSourcesOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductionsOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assetsOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assetsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources[]
  deductions: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions[]
  assets: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPersonOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions
  ),
  assets: serialized.assets.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions
  ),
  assets: deserialized.assets.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  otherPerson: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson
  liveTogether: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationshipsOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications[]
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources[]
  deductions: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions[]
  assets: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  relationships: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships[]
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_personOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions
  ),
  assets: serialized.assets.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  relationships: serialized.relationships.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions
  ),
  assets: deserialized.assets.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  relationships: deserialized.relationships.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_personOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembersOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_files = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_filesOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_files = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_files
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_personOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_person => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_person
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_application = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_applicationOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_application => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_application = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_application
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_person | null
  application: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_application
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documentsOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_application(
    serialized.application
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents_application(
    deserialized.application
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_MonitorApplication {
  __typename: 'MonitorApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  applicationType: string | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  darSubmitDate: Date | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  primaryPointOfContact: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact | null
  initialDateOfService: Date | null
  person: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_person
  householdMembers: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers[]
  documents: Person_person_allOpenHouseholdMemberApplications_MonitorApplication_documents[]
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_MonitorApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  darSubmitDate:
    serialized.darSubmitDate != null
      ? parseDate(serialized.darSubmitDate)
      : serialized.darSubmitDate,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  person: deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person(
    serialized.person
  ),
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_MonitorApplication
): Person_person_allOpenHouseholdMemberApplications_MonitorApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  darSubmitDate:
    deserialized.darSubmitDate != null
      ? formatISODate(deserialized.darSubmitDate)
      : deserialized.darSubmitDate,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  person: serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_person(
    deserialized.person
  ),
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication_documents
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications =
  | Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication
  | Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication
  | Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication
  | Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplicationsOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications'
  )
}
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications'
  )
}
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbersOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbersOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSourcesOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSourcesOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductionsOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_assetsOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_assetsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbersOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSourcesOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductionsOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assetsOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assetsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources[]
  deductions: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions[]
  assets: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPersonOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions
  ),
  assets: serialized.assets.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions
  ),
  assets: deserialized.assets.map(
    serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  otherPerson: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson
  liveTogether: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationshipsOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications[]
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources[]
  deductions: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions[]
  assets: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  relationships: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships[]
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_personOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions
  ),
  assets: serialized.assets.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  relationships: serialized.relationships.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions
  ),
  assets: deserialized.assets.map(
    serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  relationships: deserialized.relationships.map(
    serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_personOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembersOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_filesOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_personOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_applicationOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person | null
  application: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documentsOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application(
    serialized.application
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application(
    deserialized.application
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  dateOfApplication: Date | null
  requestedDateOfApplication: Date | null
  notes: string | null
  facility: string
  coveragePeriod: number | null
  charityCareType: string
  person: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_person
  householdMembers: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers[]
  documents: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents[]
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  requestedDateOfApplication:
    serialized.requestedDateOfApplication != null
      ? parseDate(serialized.requestedDateOfApplication)
      : serialized.requestedDateOfApplication,
  person: deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person(
    serialized.person
  ),
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_CharityCareApplication
): Person_person_allOpenHouseholdMemberApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  requestedDateOfApplication:
    deserialized.requestedDateOfApplication != null
      ? formatISODate(deserialized.requestedDateOfApplication)
      : deserialized.requestedDateOfApplication,
  person: serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_person(
    deserialized.person
  ),
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication_documents
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications =
  | Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication
  | Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication
  | Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication
  | Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplicationsOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications'
  )
}
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications'
  )
}
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbersOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbersOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSourcesOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSourcesOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_deductions = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_deductionsOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_deductions => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_deductions = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_deductions
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_assets = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_assetsOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_assets => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_assets = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_assets
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_assetsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbersOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSourcesOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductionsOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assetsOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assetsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources[]
  deductions: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions[]
  assets: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPersonOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions
  ),
  assets: serialized.assets.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions
  ),
  assets: deserialized.assets.map(
    serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  otherPerson: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson
  liveTogether: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationshipsOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications[]
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources[]
  deductions: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_deductions[]
  assets: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  relationships: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships[]
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_personOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_deductions
  ),
  assets: serialized.assets.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  relationships: serialized.relationships.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_deductions
  ),
  assets: deserialized.assets.map(
    serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  relationships: deserialized.relationships.map(
    serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person_relationships
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_personOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembersOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents_files = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_filesOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents_files = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_files
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_personOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_person => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_person
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents_application = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_applicationOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_application => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents_application = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_application
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_person | null
  application: Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents_application
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_documentsOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents_application(
    serialized.application
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents
): Person_person_allOpenHouseholdMemberApplications_SlideApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents_application(
    deserialized.application
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  slideType: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: Person_person_allOpenHouseholdMemberApplications_SlideApplication_person
  householdMembers: Person_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers[]
  documents: Person_person_allOpenHouseholdMemberApplications_SlideApplication_documents[]
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_SlideApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  slideType: deserializeSlideType(serialized.slideType),
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person(
    serialized.person
  ),
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_SlideApplication
): Person_person_allOpenHouseholdMemberApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  slideType: serializeSlideType(deserialized.slideType),
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_person(
    deserialized.person
  ),
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication_documents
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications =
  | Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
  | Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
  | Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication
  | Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplicationsOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications'
  )
}
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications'
  )
}
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbersOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbersOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSourcesOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSourcesOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductionsOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assetsOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assetsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbersOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSourcesOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductionsOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assetsOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assetsOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources[]
  deductions: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions[]
  assets: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPersonOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions
  ),
  assets: serialized.assets.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions
  ),
  assets: deserialized.assets.map(
    serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  otherPerson: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson
  liveTogether: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationshipsOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications[]
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources[]
  deductions: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions[]
  assets: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  relationships: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships[]
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_personOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions
  ),
  assets: serialized.assets.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  relationships: serialized.relationships.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions
  ),
  assets: deserialized.assets.map(
    serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  relationships: deserialized.relationships.map(
    serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_personOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembersOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers => ({
  ...serialized,
  person: deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_filesOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_personOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_applicationOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application => ({
  ...serialized,
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person | null
  application: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documentsOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application(
    serialized.application
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application(
    deserialized.application
  ),
})
export interface Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person
  householdMembers: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers[]
  documents: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents[]
}
export const deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication = (
  serialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplicationOrig
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person(
    serialized.person
  ),
  householdMembers: serialized.householdMembers.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents
  ),
})
export const serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication = (
  deserialized: Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication
): Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_person(
    deserialized.person
  ),
  householdMembers: deserialized.householdMembers.map(
    serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents
  ),
})
export type Person_person_allOpenHouseholdMemberApplications =
  | Person_person_allOpenHouseholdMemberApplications_MedicaidApplication
  | Person_person_allOpenHouseholdMemberApplications_MonitorApplication
  | Person_person_allOpenHouseholdMemberApplications_CharityCareApplication
  | Person_person_allOpenHouseholdMemberApplications_SlideApplication
  | Person_person_allOpenHouseholdMemberApplications_RyanWhiteApplication
export const deserializePerson_person_allOpenHouseholdMemberApplications = (
  serialized: Person_person_allOpenHouseholdMemberApplicationsOrig
): Person_person_allOpenHouseholdMemberApplications => {
  if (false || serialized.__typename === 'MedicaidApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'MonitorApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allOpenHouseholdMemberApplications'
  )
}
export const serializePerson_person_allOpenHouseholdMemberApplications = (
  deserialized: Person_person_allOpenHouseholdMemberApplications
): Person_person_allOpenHouseholdMemberApplicationsOrig => {
  if (false || deserialized.__typename === 'MedicaidApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'MonitorApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_MonitorApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_allOpenHouseholdMemberApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_allOpenHouseholdMemberApplications'
  )
}
export interface Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications =
  | Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication
  | Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication
  | Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication
  | Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplicationsOrig
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications'
  )
}
export const serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications'
  )
}
export interface Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_personOrig
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openPrimaryPointOfContactApplications_MedicaidApplication {
  __typename: 'MedicaidApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  initialDateOfService: Date | null
  mcdType: string
  mcdSubtype: string | null
  person: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication_person
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  mcdType: deserializeMcdType(serialized.mcdType),
  mcdSubtype:
    serialized.mcdSubtype != null
      ? deserializeMcdSubtype(serialized.mcdSubtype)
      : serialized.mcdSubtype,
  person: deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MedicaidApplication
): Person_person_openPrimaryPointOfContactApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  mcdType: serializeMcdType(deserialized.mcdType),
  mcdSubtype:
    deserialized.mcdSubtype != null
      ? serializeMcdSubtype(deserialized.mcdSubtype)
      : deserialized.mcdSubtype,
  person: serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication_person(
    deserialized.person
  ),
})
export interface Person_person_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContactOrig
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact => ({
  ...serialized,
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContactOrig => ({
  ...deserialized,
})
export interface Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications =
  | Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication
  | Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication
  | Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication
  | Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplicationsOrig
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications'
  )
}
export const serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications'
  )
}
export interface Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_personOrig
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openPrimaryPointOfContactApplications_MonitorApplication {
  __typename: 'MonitorApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  applicationType: string | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  darSubmitDate: Date | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  primaryPointOfContact: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact | null
  initialDateOfService: Date | null
  person: Person_person_openPrimaryPointOfContactApplications_MonitorApplication_person
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_MonitorApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  darSubmitDate:
    serialized.darSubmitDate != null
      ? parseDate(serialized.darSubmitDate)
      : serialized.darSubmitDate,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  person: deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_MonitorApplication
): Person_person_openPrimaryPointOfContactApplications_MonitorApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  darSubmitDate:
    deserialized.darSubmitDate != null
      ? formatISODate(deserialized.darSubmitDate)
      : deserialized.darSubmitDate,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  person: serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication_person(
    deserialized.person
  ),
})
export interface Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications =
  | Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication
  | Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication
  | Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication
  | Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications = (
  serialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplicationsOrig
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications'
  )
}
export const serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications'
  )
}
export interface Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person = (
  serialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_personOrig
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openPrimaryPointOfContactApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  dateOfApplication: Date | null
  requestedDateOfApplication: Date | null
  notes: string | null
  facility: string
  coveragePeriod: number | null
  charityCareType: string
  person: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication_person
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  requestedDateOfApplication:
    serialized.requestedDateOfApplication != null
      ? parseDate(serialized.requestedDateOfApplication)
      : serialized.requestedDateOfApplication,
  person: deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_CharityCareApplication
): Person_person_openPrimaryPointOfContactApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  requestedDateOfApplication:
    deserialized.requestedDateOfApplication != null
      ? formatISODate(deserialized.requestedDateOfApplication)
      : deserialized.requestedDateOfApplication,
  person: serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication_person(
    deserialized.person
  ),
})
export interface Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication
): Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication
): Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication
): Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication
): Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications =
  | Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication
  | Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication
  | Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication
  | Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications = (
  serialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplicationsOrig
): Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications'
  )
}
export const serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications
): Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications'
  )
}
export interface Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications
): Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_SlideApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person = (
  serialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication_personOrig
): Person_person_openPrimaryPointOfContactApplications_SlideApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person
): Person_person_openPrimaryPointOfContactApplications_SlideApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openPrimaryPointOfContactApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  slideType: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: Person_person_openPrimaryPointOfContactApplications_SlideApplication_person
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_SlideApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  slideType: deserializeSlideType(serialized.slideType),
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_SlideApplication
): Person_person_openPrimaryPointOfContactApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  slideType: serializeSlideType(deserialized.slideType),
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication_person(
    deserialized.person
  ),
})
export interface Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications =
  | Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
  | Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
  | Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication
  | Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
export const deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications = (
  serialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplicationsOrig
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications'
  )
}
export const serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications'
  )
}
export interface Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  serialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person {
  __typename: 'Person'
  id: string
  openApplications: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications[]
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person = (
  serialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_personOrig
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export interface Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person
}
export const deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication = (
  serialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplicationOrig
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person(
    serialized.person
  ),
})
export const serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication = (
  deserialized: Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication
): Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication_person(
    deserialized.person
  ),
})
export type Person_person_openPrimaryPointOfContactApplications =
  | Person_person_openPrimaryPointOfContactApplications_MedicaidApplication
  | Person_person_openPrimaryPointOfContactApplications_MonitorApplication
  | Person_person_openPrimaryPointOfContactApplications_CharityCareApplication
  | Person_person_openPrimaryPointOfContactApplications_SlideApplication
  | Person_person_openPrimaryPointOfContactApplications_RyanWhiteApplication
export const deserializePerson_person_openPrimaryPointOfContactApplications = (
  serialized: Person_person_openPrimaryPointOfContactApplicationsOrig
): Person_person_openPrimaryPointOfContactApplications => {
  if (false || serialized.__typename === 'MedicaidApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'MonitorApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openPrimaryPointOfContactApplications'
  )
}
export const serializePerson_person_openPrimaryPointOfContactApplications = (
  deserialized: Person_person_openPrimaryPointOfContactApplications
): Person_person_openPrimaryPointOfContactApplicationsOrig => {
  if (false || deserialized.__typename === 'MedicaidApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'MonitorApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_MonitorApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_openPrimaryPointOfContactApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Person_person_openPrimaryPointOfContactApplications'
  )
}
export interface Person_person_benefitOutcomes_application_MedicaidApplication {
  __typename: 'MedicaidApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  initialDateOfService: Date | null
  mcdType: string
  mcdSubtype: string | null
}
export const deserializePerson_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Person_person_benefitOutcomes_application_MedicaidApplicationOrig
): Person_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  mcdType: deserializeMcdType(serialized.mcdType),
  mcdSubtype:
    serialized.mcdSubtype != null
      ? deserializeMcdSubtype(serialized.mcdSubtype)
      : serialized.mcdSubtype,
})
export const serializePerson_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Person_person_benefitOutcomes_application_MedicaidApplication
): Person_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  mcdType: serializeMcdType(deserialized.mcdType),
  mcdSubtype:
    deserialized.mcdSubtype != null
      ? serializeMcdSubtype(deserialized.mcdSubtype)
      : deserialized.mcdSubtype,
})
export interface Person_person_benefitOutcomes_application_MonitorApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
}
export const deserializePerson_person_benefitOutcomes_application_MonitorApplication_primaryPointOfContact = (
  serialized: Person_person_benefitOutcomes_application_MonitorApplication_primaryPointOfContactOrig
): Person_person_benefitOutcomes_application_MonitorApplication_primaryPointOfContact => ({
  ...serialized,
})
export const serializePerson_person_benefitOutcomes_application_MonitorApplication_primaryPointOfContact = (
  deserialized: Person_person_benefitOutcomes_application_MonitorApplication_primaryPointOfContact
): Person_person_benefitOutcomes_application_MonitorApplication_primaryPointOfContactOrig => ({
  ...deserialized,
})
export interface Person_person_benefitOutcomes_application_MonitorApplication {
  __typename: 'MonitorApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  applicationType: string | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  darSubmitDate: Date | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  primaryPointOfContact: Person_person_benefitOutcomes_application_MonitorApplication_primaryPointOfContact | null
  initialDateOfService: Date | null
}
export const deserializePerson_person_benefitOutcomes_application_MonitorApplication = (
  serialized: Person_person_benefitOutcomes_application_MonitorApplicationOrig
): Person_person_benefitOutcomes_application_MonitorApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  darSubmitDate:
    serialized.darSubmitDate != null
      ? parseDate(serialized.darSubmitDate)
      : serialized.darSubmitDate,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializePerson_person_benefitOutcomes_application_MonitorApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
})
export const serializePerson_person_benefitOutcomes_application_MonitorApplication = (
  deserialized: Person_person_benefitOutcomes_application_MonitorApplication
): Person_person_benefitOutcomes_application_MonitorApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  darSubmitDate:
    deserialized.darSubmitDate != null
      ? formatISODate(deserialized.darSubmitDate)
      : deserialized.darSubmitDate,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializePerson_person_benefitOutcomes_application_MonitorApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
})
export interface Person_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  dateOfApplication: Date | null
  requestedDateOfApplication: Date | null
  notes: string | null
  facility: string
  coveragePeriod: number | null
  charityCareType: string
}
export const deserializePerson_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Person_person_benefitOutcomes_application_CharityCareApplicationOrig
): Person_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  requestedDateOfApplication:
    serialized.requestedDateOfApplication != null
      ? parseDate(serialized.requestedDateOfApplication)
      : serialized.requestedDateOfApplication,
})
export const serializePerson_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Person_person_benefitOutcomes_application_CharityCareApplication
): Person_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  requestedDateOfApplication:
    deserialized.requestedDateOfApplication != null
      ? formatISODate(deserialized.requestedDateOfApplication)
      : deserialized.requestedDateOfApplication,
})
export interface Person_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  slideType: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
}
export const deserializePerson_person_benefitOutcomes_application_SlideApplication = (
  serialized: Person_person_benefitOutcomes_application_SlideApplicationOrig
): Person_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  slideType: deserializeSlideType(serialized.slideType),
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
})
export const serializePerson_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Person_person_benefitOutcomes_application_SlideApplication
): Person_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  slideType: serializeSlideType(deserialized.slideType),
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
})
export interface Person_person_benefitOutcomes_application_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
}
export const deserializePerson_person_benefitOutcomes_application_RyanWhiteApplication = (
  serialized: Person_person_benefitOutcomes_application_RyanWhiteApplicationOrig
): Person_person_benefitOutcomes_application_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
})
export const serializePerson_person_benefitOutcomes_application_RyanWhiteApplication = (
  deserialized: Person_person_benefitOutcomes_application_RyanWhiteApplication
): Person_person_benefitOutcomes_application_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
})
export type Person_person_benefitOutcomes_application =
  | Person_person_benefitOutcomes_application_MedicaidApplication
  | Person_person_benefitOutcomes_application_MonitorApplication
  | Person_person_benefitOutcomes_application_CharityCareApplication
  | Person_person_benefitOutcomes_application_SlideApplication
  | Person_person_benefitOutcomes_application_RyanWhiteApplication
export const deserializePerson_person_benefitOutcomes_application = (
  serialized: Person_person_benefitOutcomes_applicationOrig
): Person_person_benefitOutcomes_application => {
  if (false || serialized.__typename === 'MedicaidApplication')
    return deserializePerson_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'MonitorApplication')
    return deserializePerson_person_benefitOutcomes_application_MonitorApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializePerson_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializePerson_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializePerson_person_benefitOutcomes_application_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` + 'Person_person_benefitOutcomes_application'
  )
}
export const serializePerson_person_benefitOutcomes_application = (
  deserialized: Person_person_benefitOutcomes_application
): Person_person_benefitOutcomes_applicationOrig => {
  if (false || deserialized.__typename === 'MedicaidApplication')
    return serializePerson_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'MonitorApplication')
    return serializePerson_person_benefitOutcomes_application_MonitorApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializePerson_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializePerson_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializePerson_person_benefitOutcomes_application_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` + 'Person_person_benefitOutcomes_application'
  )
}
export interface Person_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Person_person_benefitOutcomes_application | null
}
export const deserializePerson_person_benefitOutcomes = (
  serialized: Person_person_benefitOutcomesOrig
): Person_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializePerson_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializePerson_person_benefitOutcomes = (
  deserialized: Person_person_benefitOutcomes
): Person_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializePerson_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Person_person_documentFiles_documents {
  __typename: 'Document'
  id: string
}
export const deserializePerson_person_documentFiles_documents = (
  serialized: Person_person_documentFiles_documentsOrig
): Person_person_documentFiles_documents => ({...serialized})
export const serializePerson_person_documentFiles_documents = (
  deserialized: Person_person_documentFiles_documents
): Person_person_documentFiles_documentsOrig => ({...deserialized})
export interface Person_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
  documents: Person_person_documentFiles_documents[]
}
export const deserializePerson_person_documentFiles = (
  serialized: Person_person_documentFilesOrig
): Person_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
  documents: serialized.documents.map(
    deserializePerson_person_documentFiles_documents
  ),
})
export const serializePerson_person_documentFiles = (
  deserialized: Person_person_documentFiles
): Person_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
  documents: deserialized.documents.map(
    serializePerson_person_documentFiles_documents
  ),
})
export interface Person_person_accounts {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializePerson_person_accounts = (
  serialized: Person_person_accountsOrig
): Person_person_accounts => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializePerson_person_accounts = (
  deserialized: Person_person_accounts
): Person_person_accountsOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface Person_person_tasks_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializePerson_person_tasks_assignedTo = (
  serialized: Person_person_tasks_assignedToOrig
): Person_person_tasks_assignedTo => ({...serialized})
export const serializePerson_person_tasks_assignedTo = (
  deserialized: Person_person_tasks_assignedTo
): Person_person_tasks_assignedToOrig => ({...deserialized})
export interface Person_person_tasks_createdBy {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializePerson_person_tasks_createdBy = (
  serialized: Person_person_tasks_createdByOrig
): Person_person_tasks_createdBy => ({...serialized})
export const serializePerson_person_tasks_createdBy = (
  deserialized: Person_person_tasks_createdBy
): Person_person_tasks_createdByOrig => ({...deserialized})
export interface Person_person_tasks_linkedTo {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
}
export const deserializePerson_person_tasks_linkedTo = (
  serialized: Person_person_tasks_linkedToOrig
): Person_person_tasks_linkedTo => ({...serialized})
export const serializePerson_person_tasks_linkedTo = (
  deserialized: Person_person_tasks_linkedTo
): Person_person_tasks_linkedToOrig => ({...deserialized})
export interface Person_person_tasks {
  __typename: 'Task'
  id: string
  taskType: string
  assignedTo: Person_person_tasks_assignedTo
  createdBy: Person_person_tasks_createdBy
  status: string
  note: string | null
  durationMin: number | null
  dueDate: Date
  linkedTo: Person_person_tasks_linkedTo
  updatedAt: Date
}
export const deserializePerson_person_tasks = (
  serialized: Person_person_tasksOrig
): Person_person_tasks => ({
  ...serialized,
  assignedTo: deserializePerson_person_tasks_assignedTo(serialized.assignedTo),
  createdBy: deserializePerson_person_tasks_createdBy(serialized.createdBy),
  dueDate: parseDate(serialized.dueDate),
  linkedTo: deserializePerson_person_tasks_linkedTo(serialized.linkedTo),
  updatedAt: parseDate(serialized.updatedAt),
})
export const serializePerson_person_tasks = (
  deserialized: Person_person_tasks
): Person_person_tasksOrig => ({
  ...deserialized,
  assignedTo: serializePerson_person_tasks_assignedTo(deserialized.assignedTo),
  createdBy: serializePerson_person_tasks_createdBy(deserialized.createdBy),
  dueDate: formatISODate(deserialized.dueDate),
  linkedTo: serializePerson_person_tasks_linkedTo(deserialized.linkedTo),
  updatedAt: formatISO(deserialized.updatedAt),
})
export interface Person_person_webformMergeAttempts_receivedWebform_webform {
  __typename: 'Webform'
  id: string
  name: string
  slug: string
}
export const deserializePerson_person_webformMergeAttempts_receivedWebform_webform = (
  serialized: Person_person_webformMergeAttempts_receivedWebform_webformOrig
): Person_person_webformMergeAttempts_receivedWebform_webform => ({
  ...serialized,
})
export const serializePerson_person_webformMergeAttempts_receivedWebform_webform = (
  deserialized: Person_person_webformMergeAttempts_receivedWebform_webform
): Person_person_webformMergeAttempts_receivedWebform_webformOrig => ({
  ...deserialized,
})
export interface Person_person_webformMergeAttempts_receivedWebform {
  __typename: 'ReceivedWebform'
  id: string
  completedAt: Date
  response: ReceivedWebformResponse
  noPersonMatch: boolean
  createdAt: Date
  webform: Person_person_webformMergeAttempts_receivedWebform_webform
}
export const deserializePerson_person_webformMergeAttempts_receivedWebform = (
  serialized: Person_person_webformMergeAttempts_receivedWebformOrig
): Person_person_webformMergeAttempts_receivedWebform => ({
  ...serialized,
  completedAt: parseDate(serialized.completedAt),
  response: parseReceivedWebformResponse(serialized.response),
  createdAt: parseDate(serialized.createdAt),
  webform: deserializePerson_person_webformMergeAttempts_receivedWebform_webform(
    serialized.webform
  ),
})
export const serializePerson_person_webformMergeAttempts_receivedWebform = (
  deserialized: Person_person_webformMergeAttempts_receivedWebform
): Person_person_webformMergeAttempts_receivedWebformOrig => ({
  ...deserialized,
  completedAt: formatISO(deserialized.completedAt),
  response: serializeReceivedWebformResponse(deserialized.response),
  createdAt: formatISO(deserialized.createdAt),
  webform: serializePerson_person_webformMergeAttempts_receivedWebform_webform(
    deserialized.webform
  ),
})
export interface Person_person_webformMergeAttempts {
  __typename: 'WebformMergeAttempt'
  id: string
  reviewed: boolean
  mergeResult: WebformMergeResult
  receivedWebform: Person_person_webformMergeAttempts_receivedWebform
}
export const deserializePerson_person_webformMergeAttempts = (
  serialized: Person_person_webformMergeAttemptsOrig
): Person_person_webformMergeAttempts => ({
  ...serialized,
  mergeResult: parseWebformMergeResult(serialized.mergeResult),
  receivedWebform: deserializePerson_person_webformMergeAttempts_receivedWebform(
    serialized.receivedWebform
  ),
})
export const serializePerson_person_webformMergeAttempts = (
  deserialized: Person_person_webformMergeAttempts
): Person_person_webformMergeAttemptsOrig => ({
  ...deserialized,
  mergeResult: serializeWebformMergeResult(deserialized.mergeResult),
  receivedWebform: serializePerson_person_webformMergeAttempts_receivedWebform(
    deserialized.receivedWebform
  ),
})
export interface Person_person_mostRecentAccount {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializePerson_person_mostRecentAccount = (
  serialized: Person_person_mostRecentAccountOrig
): Person_person_mostRecentAccount => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializePerson_person_mostRecentAccount = (
  deserialized: Person_person_mostRecentAccount
): Person_person_mostRecentAccountOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface Person_person_mostRecentEligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializePerson_person_mostRecentEligibilityDeterminations = (
  serialized: Person_person_mostRecentEligibilityDeterminationsOrig
): Person_person_mostRecentEligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializePerson_person_mostRecentEligibilityDeterminations = (
  deserialized: Person_person_mostRecentEligibilityDeterminations
): Person_person_mostRecentEligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface Person_person {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: Person_person_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: Person_person_incomeSources[]
  deductions: Person_person_deductions[]
  assets: Person_person_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  triages: Person_person_triages[]
  openTriages: Person_person_openTriages[]
  relationships: Person_person_relationships[]
  allApplications: Person_person_allApplications[]
  openApplications: Person_person_openApplications[]
  openHouseholdMemberApplications: Person_person_openHouseholdMemberApplications[]
  allOpenHouseholdMemberApplications: Person_person_allOpenHouseholdMemberApplications[]
  openPrimaryPointOfContactApplications: Person_person_openPrimaryPointOfContactApplications[]
  benefitOutcomes: Person_person_benefitOutcomes[]
  documentFiles: Person_person_documentFiles[]
  accounts: Person_person_accounts[]
  tasks: Person_person_tasks[]
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
  webformMergeAttempts: Person_person_webformMergeAttempts[]
  mostRecentAccount: Person_person_mostRecentAccount | null
  mostRecentEligibilityDeterminations: Person_person_mostRecentEligibilityDeterminations[]
}
export const deserializePerson_person = (
  serialized: Person_personOrig
): Person_person => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializePerson_person_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializePerson_person_incomeSources
  ),
  deductions: serialized.deductions.map(deserializePerson_person_deductions),
  assets: serialized.assets.map(deserializePerson_person_assets),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  triages: serialized.triages.map(deserializePerson_person_triages),
  openTriages: serialized.openTriages.map(deserializePerson_person_openTriages),
  relationships: serialized.relationships.map(
    deserializePerson_person_relationships
  ),
  allApplications: serialized.allApplications.map(
    deserializePerson_person_allApplications
  ),
  openApplications: serialized.openApplications.map(
    deserializePerson_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializePerson_person_openHouseholdMemberApplications
  ),
  allOpenHouseholdMemberApplications: serialized.allOpenHouseholdMemberApplications.map(
    deserializePerson_person_allOpenHouseholdMemberApplications
  ),
  openPrimaryPointOfContactApplications: serialized.openPrimaryPointOfContactApplications.map(
    deserializePerson_person_openPrimaryPointOfContactApplications
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializePerson_person_benefitOutcomes
  ),
  documentFiles: serialized.documentFiles.map(
    deserializePerson_person_documentFiles
  ),
  accounts: serialized.accounts.map(deserializePerson_person_accounts),
  tasks: serialized.tasks.map(deserializePerson_person_tasks),
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
  webformMergeAttempts: serialized.webformMergeAttempts.map(
    deserializePerson_person_webformMergeAttempts
  ),
  mostRecentAccount:
    serialized.mostRecentAccount != null
      ? deserializePerson_person_mostRecentAccount(serialized.mostRecentAccount)
      : serialized.mostRecentAccount,
  mostRecentEligibilityDeterminations: serialized.mostRecentEligibilityDeterminations.map(
    deserializePerson_person_mostRecentEligibilityDeterminations
  ),
})
export const serializePerson_person = (
  deserialized: Person_person
): Person_personOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializePerson_person_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializePerson_person_incomeSources
  ),
  deductions: deserialized.deductions.map(serializePerson_person_deductions),
  assets: deserialized.assets.map(serializePerson_person_assets),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  triages: deserialized.triages.map(serializePerson_person_triages),
  openTriages: deserialized.openTriages.map(serializePerson_person_openTriages),
  relationships: deserialized.relationships.map(
    serializePerson_person_relationships
  ),
  allApplications: deserialized.allApplications.map(
    serializePerson_person_allApplications
  ),
  openApplications: deserialized.openApplications.map(
    serializePerson_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializePerson_person_openHouseholdMemberApplications
  ),
  allOpenHouseholdMemberApplications: deserialized.allOpenHouseholdMemberApplications.map(
    serializePerson_person_allOpenHouseholdMemberApplications
  ),
  openPrimaryPointOfContactApplications: deserialized.openPrimaryPointOfContactApplications.map(
    serializePerson_person_openPrimaryPointOfContactApplications
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializePerson_person_benefitOutcomes
  ),
  documentFiles: deserialized.documentFiles.map(
    serializePerson_person_documentFiles
  ),
  accounts: deserialized.accounts.map(serializePerson_person_accounts),
  tasks: deserialized.tasks.map(serializePerson_person_tasks),
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
  webformMergeAttempts: deserialized.webformMergeAttempts.map(
    serializePerson_person_webformMergeAttempts
  ),
  mostRecentAccount:
    deserialized.mostRecentAccount != null
      ? serializePerson_person_mostRecentAccount(deserialized.mostRecentAccount)
      : deserialized.mostRecentAccount,
  mostRecentEligibilityDeterminations: deserialized.mostRecentEligibilityDeterminations.map(
    serializePerson_person_mostRecentEligibilityDeterminations
  ),
})
export interface Person {
  /**
   * Person
   */
  person: Person_person
}
export const deserializePerson = (serialized: PersonOrig): Person => ({
  ...serialized,
  person: deserializePerson_person(serialized.person),
})
export const serializePerson = (deserialized: Person): PersonOrig => ({
  ...deserialized,
  person: serializePerson_person(deserialized.person),
})
export interface PersonVariables {
  id: string
}
export const deserializePersonVariables = (
  serialized: PersonVariablesOrig
): PersonVariables => ({...serialized})
export const serializePersonVariables = (
  deserialized: PersonVariables
): PersonVariablesOrig => ({...deserialized})
